export const LANG_DE_NAME = 'de';

/* Take care of an alphabetic order */
/* tslint:disable */
export const LANG_DE_TRANS = {
  ACCEPT: 'ZULASSEN',
  ACCESSIBILITY: 'Barrierefreiheit',
  ACCOUNT_DELETED_HEADING: 'Schade, dass Sie uns verlassen',
  ACCOUNT_DELETED_MESSAGE:
    'Wir haben alle Benutzerdaten erfolgreich aus unserem System entfernt. Falls Sie in Zukunft das Mietercockpit wieder nutzen wollen, freuen wir uns sehr. Dafür registrieren Sie sich bitte neu.',
  ACCOUNT_NUMBER: 'Kontonummer',
  ACCOUNT_OWNER: 'Kontoinhaber',
  ACTION_PANEL_BUTTON_TEXT: '',
  ACTIVATE_ACCOUNT: 'Benutzerkonto aktivieren',
  ADDRESS: 'Adresse',
  ADDRESS_DATA: 'Anschrift',
  ADD_NOTES_TO_NOTIFICATION_SUCCESSFULLY_REPORTED: 'Ihre Anmerkungen wurden erfolgreich übermittelt.',
  ADD_TO_CALENDAR: 'Zum Kalender hinzufügen',
  ADVERTISING_CHECKBOX_TEXT: 'Benachrichtigungen für Feedback und Informationen',
  ADVERTISING_INFO_TYPE_TEXT:
    'Ich willige ein, dass mich die Datatrain GmbH unter meiner E-Mail-Adresse kontaktiert um mich über Veranstaltungen wie z.B. Mieterfeste, Waren- und Dienstleistungen rund um das Wohnen, wie z. B. Reinigungsleistungen, oder über von Kooperationspartnern der Datatrain GmbH erbrachte Angebote zu informieren, sowie mich zu bitten, an freiwilligen Umfragen teilzunehmen. Ich kann meine Einwilligung jederzeit widerrufen.',
  ALL_CONTRACTS_FILTER_ALL_TYPES: 'Alle Arten',
  ALL_CONTRACTS_FILTER_BUTTON: 'Filter',
  ALL_CONTRACTS_FILTER_GROUPING_LABEL: 'Gruppierung',
  ALL_CONTRACTS_FILTER_HEADING: 'Sortierung & Filter',
  ALL_CONTRACTS_FILTER_RESET: 'Filter zurücksetzen',
  ALL_CONTRACTS_LABEL: 'Alle Verträge',
  ALL_CONTRACTS_SEARCH_PLACEHOLDER: 'Vertrag suchen...',
  ANALYTICS_CONSENT_MESSAGE:
    'Zur Verbesserung der App nutzen wir Matomo. Dabei werden anonymisierte Statistiken erhoben. Sie können Ihre Zustimmung jederzeit im Benutzerkonto widerrufen.',
  ANALYTICS_CONSENT_TITLE: 'Optimierung der App',
  AND: 'und',
  APPOINTMENT: 'Termin',
  APPROX: 'ca.',
  APP_ERROR: 'Fehler in der Anwendung melden',
  APP_ERROR_HEADING: 'Sie haben einen Fehler in der Anwendung festgestellt? Sagen Sie uns, was passiert ist!',
  APP_IS_LOADING: 'Bitte warten, die App wird geladen.',
  APP_TITLE: 'Mietercockpit',
  ATTACHMENTS: 'Anhänge',
  BACK: 'Zurück',
  BACK_TO_APP: 'Zurück zur Anwendung',
  BACK_TO_HOMESCREEN: 'Zurück zur Startseite',
  BAD_CONNECTION: 'Keine Internetverbindung',
  BAD_CONNECTION_TEXT: 'Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.',
  BAD_CREDENTIALS: 'Fehlerhafte Logindaten',
  BALANCE: 'Mietsaldo',
  BALANCE_RENT_ARREARS: 'Mietrückstand ausgleichen',
  BANK_CODE: 'Bankleitzahl',
  BANK_DETAILS: 'Bankverbindung',
  BEGIN: 'Beginn',
  BIC: 'BIC',
  BILLING_VIDEO: 'Abrechnungsvideo',
  BLACK: 'Schwarz',
  BROWSE_BACK: 'Zurückgehen',
  BY: 'per ',
  CANCEL: 'Abbrechen',
  CANCEL_NOTIFICATION_REASON_LABEL: 'Warum möchten Sie die Schließung dieses Anliegens beantragen?',
  CANCEL_NOTIFICATION_REQUEST_SUCCESSFULLY_REPORTED: 'Ihre Stornierungsanfrage wurde erfolgreich übermittelt.',
  CANCEL_NOTIFICATION_SUBTITLE:
    'Verklickt? Das Thema hat sich erledigt? Sie benötigen in dieser Sache keine weitere Unterstützung von Ihrem Wohnungsunternehmen? Kein Problem. Geben Sie einfach den genauen Grund für Ihren Wunsch zur Schließung des Anliegens an und wir kümmern uns um den Rest.',
  CANCEL_NOTIFICATION_TITLE: 'Anliegen zurückziehen',
  CAREER: 'Jobs & Karriere',
  CHANGE_APPOINTMENT_REQUEST_SUCCESSFULLY_REPORTED: 'Ihre Anfrage zur Terminänderung wurde erfolgreich übermittelt.',
  CHANGE_CONTRACT_CONFIRM_BUTTON: 'Trotzdem wechseln',
  CHANGE_CONTRACT_CONFIRM_TEXT:
    'Meldungsarten, Objekte und Folgefragen können je nach Vertrag unterschiedlich sein. Wenn Sie den Vertrag wechseln, startet der Assistent neu, damit keine Angaben übernommen werden, die für den neuen Vertrag nicht verfügbar sind.',
  CHANGE_CONTRACT_CONFIRM_TITLE: 'Vertrag wechseln?',
  CHANGE_CONTRACT_DIALOG_DESCRIPTION: '',
  CHANGE_CONTRACT_DIALOG_HEADER: 'Mietvertragswechsel',
  CHARACTERS: 'Zeichen',
  CHATBOT_MULTIPLE_RESULT_DESCRIPTION:
    'Damit wir ein eindeutiges Ergebnis haben, benötigen wir noch weitere Angaben von Ihnen.',
  CHATBOT_SEARCH_LABEL:
    'Nutzen Sie unsere Suche, um schnell Ihr Anliegen zu identifizieren. Wie können wir Ihnen helfen?',
  CHATBOT_SEARCH_PLACEHOLDER: 'z.B. Heizung defekt',
  CHATBOT_SEARCH_START: 'Suche',
  CHATBOT_SUCCESSFUL_RESULT_DESCRIPTION: 'Treffer',
  CHATBOT_UNIQUE_RESULT_DESCRIPTION:
    'Wir konnten ein Ergebnis zu Ihrer Suche finden. Nicht das Passende? Ändern Sie hier Ihre Angaben zum Anliegen oder nutzen Sie unseren Meldungsassistenten.',
  CHAT_BOT: 'Chatten Sie mit uns',
  CHAT_BOT_DESCRIPTION: 'Lassen Sie sich von uns durch gezielte Fragen in einem Chat beim Lösen Ihres Problems helfen.',
  CHOOSE_DATE: 'Datum wählen',
  CHOOSE_FILE: 'Datei auswählen',
  CLOSE: 'Schließen',
  CLOSED_ISSUES: 'Erledigte Anliegen',
  CODE: 'Was genau?',
  CODEGROUP: 'Was?',
  CONFIRM_DATA: 'Daten bestätigen',
  CONFIRM_PASSWORD: 'Kennwort wiederholen',
  CONFIRM_PASSWORD_ERROR: 'Die Kennwörter stimmen nicht überein',
  CONSENT: 'Einwilligungen',
  CONTACT: 'Kontakt',
  CONTACTDATA: 'Kontaktdaten',
  CONTACTS_EMAIL: 'E-Mail',
  CONTACTS_LETTER: 'Brief',
  CONTACTS_PUSH: 'Push-Nachrichten',
  CONTACTS_APP: 'in der Anwendung',
  CONTACTS_SMS: 'SMS',
  CONTACTS_TELE: 'Telefon / Mobil',
  CONTACTS_VIA: 'Kontakt via',
  CONTACT_DATA: 'Kontaktdaten',
  CONTACT_DATA_UPTODATE_DESCRIPTION:
    'Bitte prüfen Sie Ihre hinterlegten Kontaktdaten und aktualisieren Sie diese bei Bedarf.',
  CONTACT_DATA_UPTODATE_TITLE: 'Sind Ihre Kontaktdaten noch aktuell?',
  CONTACT_PERSONS: 'Kontaktpersonen',
  CONTINUE: 'Weiter',
  CONTINUE_READING: 'Weiterlesen',
  CONTRACTSELECTION: 'Mietverträge',
  CONTRACTSELECTIONINFO:
    'In der Kopfzeile des Mietercockpits können Sie jederzeit den Mietvertrag auswählen, auf den sich Ihre Aktionen beziehen.',
  CONTRACT_BEGIN: 'Vertragsbeginn',
  CONTRACT_DATA: 'Vertragsdaten',
  CONTRACT_END: 'Vertragsende',
  CONTRACT_EXPIRED_MESSAGE:
    'Ihr ausgewählter Mietvertrag ist gekündigt. 60 Tage nach Kündigung erlischt der Zugang zum Vertrag.',
  CONTRACT_NOT_ACTIVE: 'Vertrag inaktiv',
  CONTRACT_NOT_ACTIVE_TEXT:
    'Der von Ihnen gewählte Vertrag ist inaktiv, da seine Gültigkeit entweder in der Vergangenheit oder in der Zukunft liegt. Neue Anliegen können mit inaktiven Verträgen nicht aufgenommen werden.',
  CONTRACT_NUMBER: 'Mietvertragsnummer',
  CONTRACT_SUMMARY_PARTNER: 'Partner',
  CONTRACT_SUMMARY_RENT_LABEL: 'Miete / Monat',
  CONTRACT_SUMMARY_ROOMS: 'Zimmer',
  CONTRACT_SUMMARY_SINCE: 'Seit',
  COOKIEBOT_RENEW: 'Erneuern oder ändern Sie Ihre Cookie-Einwilligung',
  COOKIE_POLICY: 'Cookie-Hinweise',
  CREATED_AT: 'Angelegt am',
  CREATE_DOCUMENT: 'Dokument erstellen',
  CREATE_ISSUE: 'Anliegen absenden',
  CREATE_NEW_ISSUE: 'Anliegen jetzt absenden',
  CREATE_NOTIFICATION: 'Meldungsanlage',
  CREATE_NOTIFICATION2_STEP1_TITLE: 'Meldungsart',
  CREATE_NOTIFICATION2_STEP2_FINISHED_SELECTION: 'Auswahl abgeschlossen.',
  CREATE_NOTIFICATION2_STEP2_TITLE: 'Meldungsdetails',
  CREATE_NOTIFICATION2_STEP3_TITLE: 'Abschlussdialog',
  CREATE_NOTIFICATION2_STEP4_TITLE: 'Zusammenfassung',
  CREATE_NOTIFICATION2_WIZARD_BUTTON_BACK: 'Zurück',
  CREATE_NOTIFICATION2_WIZARD_BUTTON_NEXT: 'Weiter',
  CREATE_NOTIFICATION2_WIZARD_BUTTON_SUBMIT: 'Anliegen absenden',
  CREATE_NOTIFICATION_Header:
    'Spezifizieren Sie Ihr Anliegen Schritt für Schritt mit Hilfe unseres Meldungsassistenten.',
  CREDIT: 'Guthaben',
  CURRENT_BALANCE: 'Aktueller Mietkontostand',
  CURRENT_CONTRACT: 'Derzeitiger Vertrag',
  CURRENT_PAGE: ', aktuelle Seite',
  DAMAGE_LOCATION: 'Wo?',
  DATA_LOADING: 'Daten werden geladen',
  DATA_LOADING_DESCRIPTION: 'Einen Moment - Ihre Daten werden vorbereitet',
  DATA_LOADING_TEXT: 'Einen Moment bitte – Ihre Schadensmeldungen, Aufträge und Anträge werden vorbereitet.',
  DATE: 'Datum',
  DATE_OF_BIRTH: 'Geburtsdatum',
  DEBIT: 'Forderung',
  DECLINE: 'Ablehnen',
  DELETE: 'Löschen',
  DELETE_ACCOUNT: 'Konto löschen',
  DELETE_ACCOUNT_HEADING: 'Konto löschen',
  DELETE_ACCOUNT_NOW: 'Konto jetzt löschen',
  DELETE_ACCOUNT_SUBHEADING:
    'Sind Sie sicher, dass Sie Ihr Konto löschen wollen? Dann geben Sie bitte zur Bestätigung Ihr gültiges Kennwort ein.',
  DETAILS: 'Details',
  DOCUMENTS: 'Dokumente',
  DOCUMENT_NOT_PROVIDED: 'Dokument nicht gefunden?',
  DOCUMENT_NOT_PROVIDED_TEXT:
    'Bitte gehen Sie über „Anliegen oder Schaden melden“ um das gewünschte Dokument anzufordern oder klicken Sie einfach auf den nachfolgenden Button.',
  DONE: 'Fertig',
  DOUBLETTE_NOTIFICATION: 'Anliegen bereits aufgenommen',
  DOUBLETTE_NOTIFICATION_DISABLED: 'Es wurde bereits eine Meldung zu diesem Anliegen erstellt.',
  DOUBLETTE_NOTIFICATION_TEXT:
    'Es wurde bereits eine Meldung zu diesem Anliegen erstellt. Möchten Sie es trotzdem erneut abschicken?',
  DOWNTIME: 'Downtime',
  DOWNTIME_MESSAGE_TEXT: 'Unsere Server sind im Moment leider nicht erreichbar.',
  EDIT_2ND_FACTOR: '2-Faktor-Authentifizierung',
  EDIT_CONSENT: 'Einwilligungen bearbeiten',
  EDIT_CONTACT_DATA: 'Kontaktdaten bearbeiten',
  EDIT_CONTACT_DATA_SUCCESS: 'Ihre Kontaktdaten wurden aktualisiert.',
  EDIT_CONTACT_DATA_TEXT: 'Bitte teilen Sie uns hier eine Änderung Ihrer Daten mit:',
  EDIT_EMAIL: 'E-Mail-Adresse ändern',
  EDIT_EMAIL_TEXT: 'Bitte teilen Sie uns hier Ihre neue E-Mail-Adresse mit:',
  EDIT_NOTIFICATION_DIALOG_BLOCKED_HEADING: 'Anliegen bearbeiten nicht möglich',
  EDIT_NOTIFICATION_DIALOG_BLOCKED_TEXT1: 'Eine Rückfrage ist erst ',
  EDIT_NOTIFICATION_DIALOG_BLOCKED_TEXT2: 'nach Meldungseingang oder der letzten Rückfrage möglich',
  EDIT_PASSWORD: 'Kennwort ändern',
  EMAIL: 'E-Mail',
  EMAIL_ADDRESS: 'E-Mail-Adresse',
  EMAIL_INFORMATION_POPUP_TEXT:
    'Im System hinterlegte E-Mail Adresse und wird zur Verwaltung Ihrer Mieterdaten verwendet.',
  END: 'Ende',
  ENTER_PASSWORD: 'Kennwort eingeben',
  ENTRIES: 'Einträge',
  ERROR: 'Fehler',
  ERROR_LOGOUT_HEADING: 'Entschuldigung, Sie wurden aus technischen Gründen abgemeldet',
  ERROR_LOGOUT_MESSAGE:
    'Bitte melden Sie sich erneut an oder versuchen es später noch einmal. Sollte das Problem weiterhin bestehen, wenden Sie sich bitte an unseren Kundenservice.',
  ERROR_MODAL_HEADING: 'Verzögerung in der Datenverarbeitung',
  ERROR_MODAL_SUBHEADING:
    'Die Verarbeitung Ihrer Anfrage dauert länger als erwartet. Bitte prüfen Sie in 10 Minuten in der Anliegen-Liste, ob die Anlage ihres Anliegens erfolgreich war. Sollte dies nicht der Fall gewesen sein, versuchen Sie es bitte erneut. Wir bedauern die Unannehmlichkeiten.',
  EXTRA_LINK1: 'Erklärung zur Barrierefreiheit',
  FADING_PANEL_NEWS_HEADING: 'Neuigkeiten',
  FADING_PANEL_NEWS_LINK_TEXT: 'Alle Neuigkeiten anzeigen',
  FEEDBACK: 'Feedback',
  FILTER: 'Filter',
  FILENAME: 'Dateiname',
  FILE_TOO_LARGE: 'Die ausgewählte Datei ist zu groß. Bitte wählen Sie eine Datei unter 20MB.',
  FIRST_NAME: 'Vorname',
  FLOOR: 'Geschoss',
  FORGOT_PASSWORD: 'Kennwort vergessen?',
  FORGOT_PASSWORD_FLOW_CONFIRMATION:
    'Wenn ein Konto vorhanden ist, wurde eine E-Mail mit einem Link zum Zurücksetzen Ihres Kennworts versandt.',
  FROM: 'ab',
  FROM_DATE: 'Vom',
  FULL_ROOMS: 'ganze Räume',
  GO_TO_PIN: 'Zur PIN-Eingabe',
  HALF_ROOMS: 'Halbe Räume',
  HAS_PENDING_ONBOARDING_NOTIFICATION_HEADING: 'Ihre Daten werden geprüft',
  HAS_PENDING_ONBOARDING_NOTIFICATION_TEXT:
    'Da wir Sie nicht automatisiert als Mieter identifizieren konnten, werden Ihre Daten von einem Mitarbeiter geprüft. Wir bitten um etwas Geduld.<br>Der Vorgang wurde unter folgender Meldungsnummer aufgenommen: ',
  HEADER_MENU_DESCRIPTION: 'Menü',
  // #531, intro User label in Header for new responsive Design
  HEADER_USER_DESCRIPTION: 'Benutzerkonto',
  HEATING_AREA: 'Beheizte Fläche',
  HISTORY: 'Verlauf',
  HOME: 'Start',
  HOME_PAGE: 'Startseite',
  IBAN: 'IBAN',
  IDENTIFICATION: 'Identifikation',
  IMAGE_UPLOAD_FAILED: 'Die Bilddatei konnte nicht geladen werden. Bitte versuchen Sie es mit einem anderen Bild.',
  IMPRINT: 'Impressum',
  INFO: 'Info',
  INVALID_DATE: 'Ungültige Eingabe',
  INVALID_INPUT: 'Ungültige Eingabe',
  INVALID_TIME: 'Ungültige Eingabe',
  ISSUE_CONTENT: 'Anliegen',
  ISSUE_DETAILS: 'Meldungsdetails',
  LAST_NAME: 'Nachname',
  LEGAL_INFORMATION: 'Rechtliche Informationen',
  LETS_GO: 'Los geht’s.',
  LINE_WIDTH: 'Strichstärke',
  LIVING_SPACE_ACREAGE: 'Wohn-/Nutzfläche',
  LOCATION_ON_FLOOR: 'Lage im Geschoss',
  LOGIN: 'Anmelden',
  LOGINWELCOME: 'Willkommen beim',
  LOGIN_ERROR:
    'Bei der Anmeldung ist ein Fehler aufgetreten. Bitte überprüfen Sie Ihre Internetverbindung und versuchen es später erneut.',
  LOGOUT: 'Abmelden',
  LOGOUT_HEADING: 'Sie wurden erfolgreich abgemeldet',
  LOGOUT_MESSAGE: '',
  MAX_COMBINED_FILE_SIZE_EXCEEDED:
    'Das maximale Datenvolumen für den Datenupload wurde überschritten. Bitte reduzieren Sie die Größe oder Anzahl der Dateien.',
  MEDIUM: 'Mittel',
  MESSAGE_PANEL_LINK_TEXT: 'in Nachrichten anzeigen',
  MIGRATION_BUTTON: 'Bereits woanders registriert',
  MIGRATION_TEXT:
    'Wenn Sie sich bereits woanders registriert hatten, tippen bzw. klicken Sie hier, um ein neues Kennwort zu setzen.',
  MIMETYPE_NOT_SUPPORTED: 'Dieses Dateiformat wird leider nicht unterstützt.',
  MOBILE: 'Mobiltelefon',
  MODULE_CALENDAR: 'Termine',
  MODULE_CONSUMPTIONS: 'Verbrauch',
  MODULE_CONTRACT: 'Vertrag',
  MODULE_ISSUES: 'Meldungen',
  MODULE_NEWS: 'Neuigkeiten',
  MODULE_NOTIF_CREATE: 'Schnellhilfe',
  MODULE_NOTIF_I1: 'Dokumente',
  MODULE_NOTIF_M1: 'Feedback',
  MODULE_NOTIF_MS: 'Schaden',
  MODULE_SECTION: 'Legales',
  MONTH: 'Monat',
  MY_ACCOUNT: 'Mein Benutzerkonto',
  MY_BANK_ACCOUNT: 'Mein Mietvertrag',
  MY_CONSUMPTIONS: 'Meine Verbräuche',
  MY_CONTACT_DETAILS: 'Meine Kontaktdetails',
  MY_CONTACT_PERSONS: 'Mein Mietvertrag',
  MY_CONTRACT: 'Mein Mietvertrag',
  MY_CONTRACT_DETAILS: 'Mein Mietvertrag',
  MY_DOCUMENTS: 'Meine Dokumente',
  MY_DOORS: 'Meine Türen ',
  MY_EVENTS: 'Meine Termine',
  MY_FORMS: 'Mein Mietvertrag',
  MY_ISSUES: 'Meine Anliegen',
  MY_MESSAGES: 'Meine Nachrichten',
  MY_MOBILITY_STATION: 'Mobilitätsstation',
  MY_NEWS: 'Aktuelles',
  MY_RENT: 'Mein Mietvertrag',
  MY_SERVICE_CENTER: 'Mein Service Center',
  NAME: 'Name',
  NAME_OF_BANK: 'Name der Bank',
  NEWSLETTER: 'Newsletter',
  NEW_FILENAME: 'Neuer Dateiname',
  NEW_ISSUE: 'Neues Anliegen',
  'NEW_ITEMS_#ARIA': 'Neue Einträge',
  NEW_LOGIN: 'Neu anmelden',
  NEW_REGISTRATION: 'Neu registrieren',
  NO: 'Nein',
  NOTES: 'Anmerkungen',
  NOTES_NOT_FOUND: 'Es wurden keine Anmerkungen gefunden.',
  NOTIFICATION: 'Meldung',
  NOT_VALID_E164_ERROR_MESSAGE_1:
    'Bitte geben Sie die Telefonnummer mit Vorwahl und Rufnummer ein (z. B. +49 30 1234567).',
  NOT_YET_VERIFIED: 'Ihre E-Mail-Adresse wurde noch nicht verifiziert. Sie können noch keine Anliegen melden.',
  NOT_YET_VERIFIED_WARNING: 'Keine E-Mail-Verifizierung',
  NOT_YET_VERIFIED_WARNING_TEXT:
    'Ihre E-Mail-Adresse wurde noch nicht verifiziert! (Sollten Sie die Verifizierung auf einem anderen Gerät abgeschlossen haben, starten Sie die App bitte neu.)',
  NO_CHATS_HEADING: 'Keine Nachrichten',
  NO_CHATS_TEXT: 'Sie haben aktuell keine offenen Kommunikationen zu Ihren Anliegen.',
  NO_CONTACTS: 'Kein Kontakt zu diesem Zweck',
  NO_DATA: 'Keine Daten',
  NO_DATA_FOR_CONSUMPTION_APP: 'Leider ist für Ihre Wohnanlage keine Anzeige von Verbrauchswerten möglich.',
  NO_DATA_FOR_SINGLE_CONSENT: 'Leider sind für Ihre Anlassbezogene Einwilligung keine Daten verfügbar.',
  NO_DATA_TEXT: 'Leider sind keine Daten verfügbar.',
  NO_ENTRIES: 'Keine Einträge zum Anzeigen vorhanden.',
  NO_INFORMATION: 'Keine Angaben',
  NO_OUTCOME: 'Kein Ergebnis',
  NO_RESULT_DESCRIPTION:
    'Wir konnten leider nichts passendes zu Ihrer Suche finden. Bitte nicht aufgeben! Wir lernen stetig dazu. Bitte nutzen Sie unseren Meldungsassistenten, um Ihr Anliegen Schritt für Schritt zu spezifizieren.',
  NO_RSS_ITEMS_HEADING: 'Keine Einträge',
  NO_RSS_ITEMS_TEXT: 'Aktuell gibt es keine Einträge in diesem Bereich.',
  OCLOCK: 'Uhr',
  OF: 'von',
  OK: 'Ok',
  OPEN_CAMERA: 'Foto aufnehmen',
  OPEN_ENDED: 'unbefristet',
  OPEN_ISSUES: 'Offene Anliegen',
  OR: 'oder',
  ORDER_LIST_BY_CATEGORY: 'Liste nach Kategorie sortieren',
  ORDER_LIST_BY_DATE: 'Liste nach Datum sortieren',
  OVERVIEW: 'Übersicht',
  PAGETITLE_: 'Inhalt nicht gefunden',
  PAGETITLE_PREFIX: 'Datatrain Mietercockpit: ',
  PAGETITLE_badConnection: 'Verbindungsfehler',
  PAGETITLE_cockpit: 'Willkommensseite',
  PAGETITLE_cockpit_aktuelles: 'Aktuelles',
  PAGETITLE_cockpit_chat: 'Chat',
  PAGETITLE_cockpit_compareEmail: 'E-Mail-Adressen vergleichen ',
  PAGETITLE_cockpit_connectContract: 'Vertrag verknüpfen',
  PAGETITLE_cockpit_connectContractFailed: 'Vertragsverknüpfung fehlgeschlagen',
  PAGETITLE_cockpit_consentmanagement: 'Einwilligungsmanagement',
  PAGETITLE_cockpit_customContent: 'Servicetipps',
  PAGETITLE_cockpit_documents: 'Dokumente',
  PAGETITLE_cockpit_documents2: 'Dokumente',
  PAGETITLE_cockpit_dokumenteAnfordern: 'Dokumente anfordern',
  PAGETITLE_cockpit_enterPin: 'PIN-Eingabe',
  PAGETITLE_cockpit_faq_faq: 'FAQ',
  PAGETITLE_cockpit_meinMietvertrag: 'Mein Mietvertrag',
  PAGETITLE_cockpit_meinMietvertrag_bankdetails: 'Bankverbindung',
  PAGETITLE_cockpit_meinMietvertrag_dokumenteAnfordern: 'Dokumente anfordern',
  PAGETITLE_cockpit_meinMietvertrag_kontaktdaten: 'Meine Kontaktdaten',
  PAGETITLE_cockpit_meinMietvertrag_kontaktpersonen: 'Kontaktpersonen',
  PAGETITLE_cockpit_meinMietvertrag_kontostand: 'Kontostand',
  PAGETITLE_cockpit_meinMietvertrag_miete: 'Details des Mietvertrags',
  PAGETITLE_cockpit_meinMietvertrag_uebersicht: 'Mietvertrag Hauptmenü',
  PAGETITLE_cockpit_meinMietvertrag_vertragsdaten: 'Meine Vertragsdaten',
  PAGETITLE_cockpit_meineAnliegen: 'Meine Anliegen',
  PAGETITLE_cockpit_meineAnliegen_details: 'Anliegendetails',
  PAGETITLE_cockpit_meineAnliegen_uebersicht: 'Meine Anliegen',
  PAGETITLE_cockpit_mieterbefragung: 'Mieterbefragung',
  PAGETITLE_cockpit_mobilityStation: 'Mobilitätsstation',
  PAGETITLE_cockpit_osconomyVerbrauch_home: 'Verbrauchsdaten',
  PAGETITLE_cockpit_pin: 'PIN-Verifizierung',
  PAGETITLE_cockpit_requestPin: 'PIN anfordern',
  PAGETITLE_cockpit_rss: 'RSS Feed',
  PAGETITLE_cockpit_serviceCenter: 'Service Center',
  PAGETITLE_cockpit_singleconsent: 'Anlassbezogene Einwilligungen',
  PAGETITLE_cockpit_start: 'Hauptmenü',
  PAGETITLE_cockpit_startIssue: 'Service kompakt',
  PAGETITLE_cockpit_tueren: 'Meine Türen',
  PAGETITLE_cockpit_tueren_teilen: 'Türzugänge teilen',
  PAGETITLE_cockpit_userRejected: 'Nutzer abgelehnt',
  PAGETITLE_cockpit_verbrauch: 'Meine Verbräuche',
  PAGETITLE_cockpit_welcome: 'Willkommensseite',
  PAGETITLE_error: 'Fehler',
  PAGETITLE_login: 'Login und Registrierung',
  PAGETITLE_loginAndRegistration_createAccount: 'Benutzerkonto erstellen',
  PAGETITLE_loginAndRegistration_landingPage: 'Login und Registrierung',
  PAGETITLE_loginWithoutRegistration: 'Login',
  PAGETITLE_logout: 'Login und Registrierung',
  PAGETITLE_lpa_consentmanagement: 'Einwilligungsmanagement',
  PAGETITLE_lpa_documents2: 'Dokumente',
  PAGETITLE_lpa_start: 'Identifikation',
  PAGETITLE_newemail: 'Neue E-Mail-Adresse verifizieren',
  PAGETITLE_publicSurvey: 'Öffentliche Umfrage',
  PAGETITLE_requestpassword: 'Kennwort angefordert',
  PAGETITLE_serviceNotAvailable: 'Service nicht verfügbar',
  PAGETITLE_setpassword: 'Kennwort setzen',
  PAGETITLE_termsOfUseAndPrivacyPolicyAgreement: 'Nutzungsbedingungen',
  PAGETITLE_unlock: 'Freischalten',
  PAGETITLE_updateRequired: 'Update notwendig',
  PAGETITLE_verifyemail: 'Email verifizieren',
  PARTNER_ID: 'GP-Nummer',
  PASSWORD: 'Kennwort',
  PAYMENT_BUTTON: 'Daten absenden',
  PAYMENT_HEADING: 'Mietrückstand',
  PENDING: 'in Bearbeitung',
  PHONE: 'Telefon',
  PLEASE_CHOOSE: 'Bitte wählen ...',
  PRIVACY: 'Datenschutz',
  PRIVACY_AGREEMENT: 'Datenschutz- und wettbewerbsrechtliche Einwilligungserklärung',
  PRIVACY_POLICY: 'Datenschutz',
  PROPERTIES: 'Objekte',
  PROPERTY: 'Objekt',
  PROPERTY_SELECTION: 'Bitte Vertragsgegenstand auswählen',
  QUERY_NOTIFICATION_TILE_DESCRIPTION:
    'Handelt es sich um eine Rückfrage zu einem bereits aufgenommenen Vorgang? Nutzen Sie dafür die Funktion in der entsprechenden Meldung.',
  QUERY_NOTIFICATION_TILE_TITLE: 'Rückfrage',
  RANGE_VALIDATION_SMALLER_ERROR: 'Fehler: Das 2. Datum muss größer als das Erste sein!',
  RED: 'Rot',
  REGISTER: 'Registrieren',
  RENT: 'Miete',
  RENTAL_CONTRACT: 'Mietvertrag',
  REPORTER: 'Melder',
  'REPORTER_BUTTON_#ARIA': 'Reporter Button',
  REQUEST: 'Anfordern',
  REQUEST_CHANGE_EMAIL:
    'Eine E-Mail zum Ändern Ihrer hinterlegten E-Mail-Adresse wurde an ihre neue E-Mail-Adresse gesandt.',
  REQUEST_CHANGE_PW: 'Eine E-Mail zum Ändern Ihres Kennworts wurde Ihnen zugesandt.',
  REQUEST_DOCUMENT: 'Anliegen absenden',
  REQUEST_DOCUMENTS: 'Dokumente anfordern',
  RESET: 'Zurücksetzen',
  RESET_SIGNATURE: 'Unterschrift zurücksetzen',
  RETRY: 'Zum Wiederholen tippen',
  ROOMS: 'Räume',
  ROUTER_LINK_TEXT: 'Mehr erfahren',
  RUBRIC: 'Rubrik',
  SAVE: 'Speichern',
  SCREEN1_TEXT: 'Datatrain Standardtext für Screen1.',
  SCREEN2_TEXT: 'Datatrain Standardtext für Screen2.',
  SCREEN3_TEXT: 'Datatrain Standardtext für Screen3.',
  SEARCH: 'Suche',
  SELECT_CONTRACT: 'Ihr Anliegen bezieht sich auf folgenden Vertrag:',
  SELECT_CONTRACT_FIRST: 'Bitte wählen Sie zuerst einen Vertrag aus.',
  SELECT_CONTRACT_LABEL: 'Ausgewählt: ',
  SELECT_CONTRACT_PLACEHOLDER: 'Bitte Vertrag auswählen',
  SELECT_NOTIF_TYPE_HEADING: 'Service kompakt',
  SELECT_NOTIF_TYPE_SUBHEADING:
    'Sie möchten einen Schaden melden, eine Genehmigung einholen oder haben eine Beschwerde? Hier sind Sie richtig.',
  SELECT_PROPERTY: 'Ihr Anliegen bezieht sich auf folgendes Objekt:',
  SELECT_YOUR_CONTRACT: 'Zu welchem Vertrag möchten Sie die Informationen einsehen?',
  SELECT_YOUR_NOTIFICATION_TYPES: 'Wie möchten Sie über Neuigkeiten zu Ihren Anliegen benachrichtigt werden?',
  SELECT_YOUR_NOTIFICATION_TYPES_DESCRIPTION: 'Bitte wählen Sie aus, auf welche Weise Sie Kontaktiert werden wollen.',
  SEND: 'Absenden',
  SEND_BY_MAIL: 'Sie erhalten das Dokument per Post oder per E-Mail',
  SEND_DATA: 'Daten senden',
  SEND_ERROR_LOG: 'Fehlerbericht senden',
  SEND_VERIFY_LINK: 'Verifizierungslink erneut senden',
  SERVICE_NOT_AVAILABLE:
    'Der Service ist momentan leider nicht verfügbar. Bitte versuchen Sie es zu einem späteren Zeitpunkt noch einmal.',
  SERVICE_PROVIDER_CONTACT_HINT: 'Für Rückfragen, Terminänderung und Weiteres rufen Sie uns bitte an.',
  SEVERAL_RESULTS: 'Mehrere Treffer',
  SHOW_ALL: 'Alle anzeigen',
  SHOW_MORE: 'Mehr anzeigen',
  SKIP_TO_MAIN_CONTENT: 'Zum Hauptinhalt springen',
  SOMETHING_WENT_WRONG: 'Entschuldigung, es ist ein Fehler aufgetreten.',
  SOMETHING_WENT_WRONG_TEXT:
    'Bitte probieren Sie es später nochmal oder wenden Sie sich an die Mieterbetreuung. Vielen Dank.',
  START_ISSUE: 'Anliegen erstellen',
  START_NEW_ISSUE: 'Meldungsdialog starten',
  STATUS: 'Status',
  STEP: 'Schritt',
  STROKE_COLOR: 'Farbe',
  SUBMIT_ANYWAY: 'Trotzdem abschicken',
  SUBMIT_CHANGES: 'Änderungen abschicken',
  SUBSCRIBE: 'Abonnieren',
  SUCCESS: 'Erfolgreich',
  SUPPORT: 'Support',
  SUPPORT_ACTIVE: 'aktive Session',
  SUPPORT_CHECKBOX_TEXT: 'Ja, ich erlaube den Datenzugriff während einer Support-Session',
  SUPPORT_INACTIVE: 'keine aktive Session',
  SUPPORT_MESSAGE_SUCCESS: 'Support Modus aktiv',
  SUPPORT_MESSAGE_WARNING: 'Bitte starten sie den Support-Modus in der Fiori App',
  SUPPORT_STATUS: 'Supportstatus',
  SURVEY: 'Mieterbefragung',
  SURVEY_CHECKBOX_TEXT: 'Ja, ich möchte gerne an Mieterbefragungen teilnehmen',
  TENANT_NUMBER: 'Mieternummer',
  TENANT_SURVEY_SUBMISSION_ERROR_MESSAGE:
    'Beim Übermitteln Ihrer Teilnahme an der Befragung ist ein Fehler aufgetreten.',
  TENANT_SURVEY_SUBMISSION_SUCCESS_MESSAGE: 'Ihre Teilnahme an der Befragung wurde erfolgreich übermittelt!',
  TERMS_OF_USE: 'Allgemeine Geschäftsbedingungen',
  TESTVERSION: 'Testversion',
  TESTVERSION_TEXT:
    'Bitte testen Sie die neueste Version.\n Ob eine neue Version verfügbar ist, verrät Ihnen Apple TestFlight bzw. der Google Play Store. Sollte eine neue Version verfügbar sein, löschen Sie bitte zunächst die aktuelle Version und laden die neue Version dann auf Ihr Smartphone.',
  THICK: 'Dick',
  THIN: 'Dünn',
  TIMEOUT_HEADING: 'Sie wurden abgemeldet',
  TIMEOUT_MESSAGE: 'Auf Grund von Inaktivität wurden Sie vom System abgemeldet. Bitte melden Sie sich erneut an.',
  TO: 'bis',
  TOGGLE_NAVIGATION: 'Menü einblenden',
  TOTAL: 'Gesamt',
  TOTAL_RENT: 'Gesamtmiete',
  TOTAL_TAX: 'Mehrwertsteuer',
  TRACKING: 'Nutzungsstatistiken',
  TRACKING_CHECKBOX_TEXT: 'Ja, ich erlaube die Erfassung von Nutzungsstatistiken',
  TYPE_OF_USE: 'Vertragsart',
  UI_0_9_DOWN: 'Null bis Neun abwärts',
  UI_9_0_DOWN: 'Neun bis Null abwärts',
  UI_9_0_UP: 'Neun bis Null aufwärts',
  UI_ACCEPTED: 'Akzeptieren',
  UI_ADD: 'Hinzufügen',
  UI_ADD_OPEN: 'Hinzufügen',
  UI_ARROW_DOWN: 'Abwärts',
  UI_ARROW_UP: 'Aufwärts',
  UI_BELL: 'Benachrichtigungen',
  UI_CALCULATOR: 'Berechnen',
  UI_CALENDAR: 'Termin einstellen',
  UI_CAMERA: 'Foto hinzufügen',
  UI_CHECK: 'Prüfen',
  UI_CHECKBOX: 'Auswählen',
  UI_CHECKBOX_CHECKED: 'Ausgewählt',
  UI_CIRCLE: 'Einkreisen',
  UI_CLARIFY: 'Hilfe',
  UI_CLIP: 'Anhang',
  UI_CLIPBOARD: 'Zwischenablage',
  UI_CLIPBOARD_CANCELED: 'Zwischenablage abbrechen',
  UI_CLIPBOARD_CHECK: 'Zwischenablage prüfen',
  UI_CLIPBOARD_CHECKS: 'Zwischenablagen prüfen',
  UI_CLOSE: 'Schließen',
  UI_CLOSE_THIN: 'Schließen',
  UI_CLOSE_THINNER: 'Schließen',
  UI_CLOSE__BANKACCOUNT_EDIT: 'Dialog "Bankverbindung bearbeiten" schließen',
  UI_CLOSE__DELETE_ACCOUNT: 'Kontolöschen schließen',
  UI_CLOSE__DIALOG: 'Dialog schließen',
  UI_CLOSE__EDIT_EMAIL: 'Dialog "E-Mail bearbeiten" schließen ',
  UI_CLOSE__ISSUE: 'Dialog "Anliegen melden" schließen',
  UI_CLOSE__MESSAGE: 'Meldung schließen',
  UI_CLOSE__MESSAGES: 'Meldungen schließen',
  UI_CLOSE__NAVIGATION_DRAWER: 'Menü schließen',
  UI_CLOSE__NOT_VERIFIED: 'Dialog "Nicht verifiziert" schließen',
  UI_CLOSE__REGISTRATION_FAILED: ' Dialog "Registrierung fehlgeschlagen" schließen',
  UI_CLOSE__SHARE_OFFER: 'Dialog "Angebot weiterempfehlen" schließen',
  UI_CLOSE__SURVEY: 'Umfrage schließen',
  UI_CLOSE__TESTVERSION: 'Dialog "Testversion" schließen',
  UI_CLOSE__USER: 'Benutzerkonto schließen',
  UI_COG: 'Einstellungen',
  UI_COMPANY_LOGO: 'Logo der Datatrain',
  UI_DATATRAIN_LOGO: 'Datatrain',
  UI_DECLINED: 'Ablehnen',
  UI_DELETE_FILE: 'Datei löschen',
  UI_DOCUMENT: 'Dokument',
  UI_DOCUMENT_ARCHIVE: 'Dokument_Archiv',
  UI_DOCUMENT_GRAPH: 'Grafik_Dokumente',
  UI_DOCUMENT_IMAGE: 'Bild_Dokumente',
  UI_DOCUMENT_TEXT: 'Text_Dokumente',
  UI_DOWNLOAD: 'Herunterladen',
  UI_DOWNLOAD_FILE: 'Datei herunterladen',
  UI_DUPLICATE: 'Klonen',
  UI_ELLIPSIS: 'Weiteres',
  UI_EXPECTED: 'Warten',
  UI_EXTERNAL_LINK: 'Externer Link',
  UI_EYE: 'Einsehen',
  UI_FACE_ID: 'Gesichtserkennung',
  UI_FILTER: 'Filtern',
  UI_FLAG: 'Markieren',
  UI_FOLDER_BUILDING: 'Ordner erstellen',
  UI_FOLDER_USER: 'Personalakte',
  UI_HIDEPASSWORD: 'Kennwort unkenntlich machen.',
  UI_INFO: 'Informieren',
  UI_LIST: 'Liste',
  UI_LOCATION: 'Lokalisieren',
  UI_LOCK: 'Abschließen',
  UI_LOCK_OPEN: 'Aufschließen',
  UI_MAP_PIN: 'Platzierung',
  UI_MENU: 'Menü',
  UI_NAVIGATE_TO_CHAT: 'Zur Chat-Übersicht gehen',
  UI_NOTE_ADD: 'Notiz hinzufügen',
  UI_NOTIFICATION_DAMAGE: 'Schaden melden',
  UI_NOTIFICATION_FEEDBACK: 'Feedback geben',
  UI_NOTIFICATION_HANDOVER: 'Übergabe melden',
  UI_NOTIFICATION_INSPECTION: 'Inspektion beantragen',
  UI_NOTIFICATION_INSURANCE: 'Versicherungsfall melden',
  UI_NOTIFICATION_OTHER: 'Weiteres melden',
  UI_NOTIFICATION_PRE_TAKEOVER: 'Vorabnahme beantragen',
  UI_NOTIFICATION_QUALITY_ASSURANCE: 'Qualitätskontrolle anfragen',
  UI_NOTIFICATION_SAFETY_CHECK: 'Sicherheitscheck anfragen',
  UI_NOTIFICATION_TAKEOVER: 'Übergabe beantragen',
  UI_NOTIFICATION_TENANT_REQUEST: 'Mieter melden',
  UI_NOTIFICATION_TREE_INSPECTION: 'Baumbegehung beantragen',
  UI_NOT_POSSIBLE: 'Nicht möglich',
  UI_OPEN_DIALOG: 'Dialog öffnen',
  UI_OPEN_DOWN: 'Öffnen',
  UI_OPEN_FILE: 'Datei öffnen',
  UI_OPEN_LEFT: 'Nach links',
  UI_OPEN_RIGHT: 'Nach rechts',
  UI_OPEN_UP: 'Nach oben',
  UI_PENCIL: 'Bearbeiten',
  UI_POINTER_DOWN: 'Abwärts',
  UI_POINTER_LEFT: 'Links',
  UI_POINTER_RIGHT: 'Rechts',
  UI_POINTER_UP: 'Aufwärts',
  UI_PRINTER: 'Drucken',
  UI_RADIO: 'Option wählen',
  UI_RADIO_CHECKED: 'Option gewählt',
  UI_RECEIPT: 'Beleg',
  UI_REMOVE: 'Entfernen',
  UI_REMOVE_OPEN: 'Entfernen',
  UI_RESEND_PIN: 'Pineingabe absenden',
  UI_SEARCH: 'Suchen',
  UI_SECTION: 'Sektion',
  UI_SHOWPASSWORD: 'Kennwort anzeigen.',
  UI_SORT: 'Sortieren',
  UI_STAR: 'Markieren',
  UI_STAR_FILLED: 'Markiert',
  UI_SYNC: 'Synchronisieren',
  UI_THROBBER: 'Laden',
  UI_TILES: 'Kacheln',
  UI_TIME: 'Zeit',
  UI_TIME_REMAINS: 'Restzeit',
  UI_TOUCH_ID: 'Mit Fingerabdruck verifizieren',
  UI_TRASH: 'Entfernen',
  UI_TRASH_UPLOADED: 'Hochgeladene Datei oder Bild entfernen',
  UI_TREE_LIST: 'Hierarchische Liste',
  UI_UPLOAD: 'Hochladen',
  UI_UPLOADED_IMG: 'Hochgeladenes Bild',
  UI_UPLOAD_FILE: 'Datei hochladen',
  UI_UPLOAD_FILE_IMG: 'Datei oder Bild hochladen',
  UI_UPLOAD_PICTURE: 'Foto hochladen',
  UI_USER: 'Nutzer',
  UI_USER_BUILDER: 'Bauarbeiter',
  UI_USER_CLERK: 'Mitarbeiter',
  UI_USER_HANDYMAN: 'Handwerker',
  UI_USER_MANAGER: 'Manager',
  UI_VIDEO: 'Video abspielen',
  UI_WARNING: 'Warnung',
  UI_WARNING_CIRCLE: 'Warnung',
  UI_Z_A_DOWN: 'Z bis A abwärts',
  UI_a_z_DOWN: 'A bis Z abwärts',
  UI_a_z_UP: 'A bis Z aufwärts',
  UNDO: 'Rückgängig',
  UNLOCK: 'Entsperren',
  UNLOCK_BIO: 'Finger/Gesicht',
  UPDATE: 'Aktualisieren',
  UPDATE_DATA: 'Daten aktualisieren',
  UPDATE_REQUIRED_HEADER: 'Aktualisierung erforderlich',
  UPDATE_REQUIRED_TEXT:
    'Ihre Anwendung ist veraltet. Bitte aktualisieren Sie die App über den AppStore bzw. PlayStore. ',
  UPLOAD_DOCUMENT: 'Dokument hochladen',
  USAGE: 'Verwendungszweck',
  USERPAGE_HEADING: 'Mein Benutzerkonto',
  USERPAGE_SUBHEADING: 'Hier können Sie Informationen zu Ihrem Nutzerkonto einsehen und ändern.',
  USER_CHANGED_CONTRACT: 'Benutzer hat den Vertrag gewechselt',
  USER_DATA: 'E-Mail und Kennwort',
  USER_INACTIVE_HEADING: 'Sie wurden ausgeloggt',
  USER_INACTIVE_MESSAGE: 'Ihr Benutzerkonto ist nicht mehr aktiv.',
  USER_PAGE: 'Benutzerkonto',
  UVI_CHECKBOX_TEXT: 'Ja, ich möchte die UVI zusätzlich per Post erhalten.',
  UVI_INFO_TYPE_TEXT:
    'Hier können Sie den postalischen Versand ihrer unterjährigen Verbrauchsinformation beantragen. Zustimmung gilt zum jeweilig nächsten Stichtag. Die Kosten für den postalischen Versand trägt der jeweilige Haushalt.',
  UVI_TITLE: 'Bereitstellung der unterjährigen Verbrauchsinformation (UVI)',
  VALID: 'gültig',
  VENDOR: 'Dienstleister',
  VERIFICATION_REQUESTED: 'Eine neue E-Mail wurde Ihnen zugesandt',
  VERIFY_NOW: 'Jetzt prüfen',
  VERSION: 'Version',
  WARNING: 'Warnung',
  WEBSITE: 'Webseite',
  WHITE: 'Weiß',
  WRONG_PASSWORD: 'Fehlerhafte Logindaten',
  YES: 'Ja',
};

export const LANG_DE_AGREEMENT_TRANS = {
  ACCEPT: 'Ich stimme den Änderungen zu',
  AGREEMENT_TEXT_1: 'Wir haben unsere',
  AGREEMENT_TEXT_2:
    'aktualisiert. Bitte lesen Sie sich die Änderungen aufmerksam durch. Hier gelangen Sie zu der aktuellen Version:',
  AGREEMENT_TEXT_3: 'Um das Mietercockpit weiterhin nutzen zu können, bestätigen Sie bitte, dass Sie die neuen',
  AGREEMENT_TEXT_4: 'gelesen und verstanden haben und diesen zustimmen.',
  CHANGE_OF: 'Änderung der',
  DELETE_ACCOUNT: 'Konto löschen',
  DELETE_ACCOUNT_TEXT: 'Möchten Sie den Änderungen nicht zustimmen, können Sie jederzeit Ihr',
  PRIVACY_POLICY_AND_TERMS_OF_USE: 'Datenschutzrichtlinien und Nutzungsbedingungen',
};

export const LANG_DE_CONSUMPTIONS_TRANS = {
  BENCHMARK_LEGEND_TEXT: 'Normierter Durchschnittsverbrauch',
  BENCHMARK_LEGEND_TEXT_SHORT: 'Vergleichswert Wohnhausgruppe',
  CHART_INFO: 'Alle folgenden Werte in',
  COLD_WATER: 'Kaltwasser',
  COLD_WATER_SUBHEADING:
    'Hier finden Sie Ihre Kaltwassermesswerte und erhalten eine klare Sicht auf Ihren Verbrauch zur effizienteren Nutzung Ihres Kaltwassers.',
  CONSUMPTION_HISTORY: 'Verbrauchshistorie',
  CONSUMPTIONS_TABLE_DISCLAIMER_HEATING:
    'Mit “!” gekennzeichnete Werte wurden geschätzt, da mindestens einer der bei Ihnen verbauten Heizkostenverteiler / Wärmemengenzähler  keine Werte per Funk übermittelt hat.',
  CONSUMPTIONS_TABLE_DISCLAIMER_HOT_WATER:
    'Mit “!” gekennzeichnete Werte wurden geschätzt, da mindestens einer der bei Ihnen verbauten Wasserzähler  keine Werte per Funk übermittelt hat.',
  CONSUMPTIONS_TABLE_DISCLAIMER_COLD_WATER:
    'Mit “!” gekennzeichnete Werte wurden geschätzt, da mindestens einer der bei Ihnen verbauten Wasserzähler  keine Werte per Funk übermittelt hat.',
  CURRENT_CONSUMPTIONS: 'Aktueller Verbrauch',
  DISABLED_TILE_TEXT_HEATING:
    'Leider können keine Verbrauchswerte dargestellt werden, da die Heizungsversorgung in Ihrem Haus entweder dezentral erfolgt oder aus technischen Gründen keine Zähler installiert sind.',
  DISABLED_TILE_TEXT_HOT_WATER:
    'Leider können keine Verbrauchswerte dargestellt werden, da die Warmwasserbereitung in Ihrem Haus entweder dezentral erfolgt oder aus technischen Gründen keine Zähler installiert sind.',
  DISABLED_TILE_TEXT_COLD_WATER:
    'In Ihrem Haus sind keine Kaltwasserzähler installiert, so dass keine Verbrauchswerte erfasst und dargestellt werden können.',
  HEATING: 'Heizung',
  HEATING_SUBHEADING:
    'Hier finden Sie Ihre Heizungsmesswerte und erhalten eine klare Sicht auf Ihren Verbrauch zur effizienteren Nutzung Ihrer Heizung.',
  HINT: 'Hinweis',
  HOT_WATER: 'Warmwasser',
  HOT_WATER_SUBHEADING:
    'Hier finden Sie Ihre Warmwassermesswerte und erhalten eine klare Sicht auf Ihren Energieverbrauch zur effizienteren Nutzung Ihres Warmwassers.',
  KWH: 'kWh',
  LAST_READING_DATE: 'Letzte verfügbare Messung',
  M3: 'm³',
  PAGE_HEADING: 'Meine Verbräuche',
  PAGE_SUBHEADING: 'Immer alles im Blick: Wie es um Ihre Verbräuche von Wärme, Warmwasser und Kaltwasser steht.',
  PERIOD: 'Zeitraum',
  PREVIOUS_CONSUMPTIONS: 'Vorjahresverbrauch',
  SOURCE: 'Quelle',
  TABLE_INFO_1: 'Verbrauch wird berechnet als Differenz Zählerstand x Faktor umgerechnet in',
  TABLE_INFO_2: 'Den Faktor entnehmen Sie bitte der Heizkostenabrechnung.',
  TIPS_AND_TRICKS: 'Tipps & Tricks zum Energiesparen',
  TREND_DESCRIPTION_HEATING: 'Trend Vergleichswert: Vormonat',
  TREND_DESCRIPTION_HOT_WATER: 'Trend Vergleichswert: Vormonat',
  TREND_DESCRIPTION_COLD_WATER: 'Trend Vergleichswert: Vormonat',
};

export const LANG_DE_SERVICE_CENTER_TRANS = {
  PAGE_HEADING: 'Service Center',
  PAGE_SUBHEADING: 'Hier gibt es Informationen zum Service Center',
};

export const LANG_DE_CONTRACT_TRANS = {
  PAGE_HEADING: 'Einfach zuhause',
  PAGE_SUBHEADING:
    'Ihr Vertrag auf einen Klick: Daten einsehen, Unterlagen anfordern oder Ansprechpartner kontaktieren.',
};

export const LANG_DE_CONTRACT_BANK_ACCOUNT_DETAILS_TRANS = {
  DEBIT_MANDATE_FORM: 'SEPA-Lastschrift Formular',
  EDIT_BANK_ACCOUNT_DATA: 'Bankverbindung ändern',
  EDIT_BANK_ACCOUNT_DATA_INFO_TEXT: '  ',
  EDIT_BANK_ACCOUNT_DATA_HEADING: 'Bankverbindung ändern',
  EDIT_BANK_ACCOUNT_DATA_WARNING_TEXT:
    'Hinweis: Ihre Änderungen beziehen sich nur auf den aktuell ausgewählten Mietvertrag. Möchten Sie Ihre Zahlungsmodalitäten für weitere Mietverträge anpassen, dann wechseln Sie bitte in den entsprechenden Vertrag und wiederholen Ihre Eingaben.',
  EDIT_BANK_ACCOUNT_OWNER: 'Abweichender Kontoinhaber?',
  EDIT_BANK_ACCOUNT_OWNER_HEADING: 'Abweichender Kontoinhaber',
  GRANT_DEBIT_MANDATE_HEADING: 'Lastschriftmandat erteilen',
  NO_DEBIT_MANDATE_TEXT1: 'Mietzahlung fristgerecht und sicher per Lastschriftverfahren',
  NO_DEBIT_MANDATE_TEXT2:
    'Lassen Sie die Miete bequem von Ihrem Konto mittels SEPA-Lastschrift abbuchen. Hier gelangen Sie zum Formular mit dem Sie uns die Einzugsermächtigung erteilen können.',
  PAGE_HEADING: 'Bankverbindung',
  PAGE_SUBHEADING:
    'Ihre Bankverbindung hat sich geändert? Teilen Sie uns an dieser Stelle bequem online Ihre neuen Kontodaten mit.',
  PAGE_SUBHEADING_NO_DEBIT_MANDATE: 'Sie haben kein SEPA-Lastschriftmandat für Ihre Mietzahlung erteilt.',
  SAVE_BANK_ACCOUNT_DATA: 'Bankverbindung ändern',
  USAGE: 'Verwendungszweck',
};

export const LANG_DE_CONTRACT_CONTACT_DETAILS_TRANS = {
  PAGE_HEADING: 'Kontaktdaten',
  PAGE_SUBHEADING: 'Sind Ihre Angaben aktuell? Um für Sie da zu sein, möchten wir Sie kontaktieren können.',
};

export const LANG_DE_CONTRACT_CONTACT_PERSONS_TRANS = {
  PAGE_HEADING: 'Kontaktpersonen',
  PAGE_SUBHEADING:
    'Es gibt auch Anliegen, die Sie telefonisch oder direkt mit einem unserer Dienstleister erledigen müssen – hier finden Sie weitere wichtige Kontaktdaten:',
  SHOW_ADDRESS_ON_MAP: 'Standort in Karte anzeigen',
};

export const LANG_DE_CONTRACT_CONTRACT_DETAILS_TRANS = {
  CONTRACT_INFORMATION: 'Vertragsdaten',
  CONTRACT_TENANTS_INFORMATION: 'Personen',
  INVITE: 'Einladen',
  INVITE_PARTNER_HEADING: 'Aktivierung',
  INVITE_PARTNER_DESCRIPTION: 'VertragspartnerIn einladen zu Vertrag:',
  INVITE_PARTNER_DESCRIPTION2:
    '<br><br>Bitte prüfen Sie, dass es sich um die aktuelle E-Mail-Adresse der einzuladenden Person handelt. Wenn keine E-Mail-Adresse angezeigt wird, tragen Sie bitte die E-Mail-Adresse der einzuladenden Person ein.',
  IS_APP_USER: 'Nutzer',
  IS_INVITED: 'Eingeladen',
  NO_EMAIL_ADDRESS: 'keine E-Mail-Adresse',
  NOTICE_PERIOD: 'Kündigungsfrist',
  PAGE_HEADING: 'Vertragsdaten',
  PAGE_SUBHEADING:
    'Finden Sie auf einen Klick die wichtigsten Infos rund um Ihr Mietverhältnis: Schauen Sie nach Vertragsbeginn, weiteren Personen zum Vertrag oder Informationen zur Wohnfläche.',
  SUBMIT: 'Senden',
};

export const LANG_DE_CONTRACT_RENT_DETAILS_TRANS = {
  BALANCE_DISCLAIMER: '',
  BALANCE_INFO_TEXT:
    'Bitte beachten Sie, dass etwaige Mietminderungen erst nach Abschluss der Arbeiten berechnet und Ihrem Mietkonto gutgeschrieben werden. Diesbezüglich werden wir unaufgefordert auf Sie zukommen.',
  BILLING_VIDEO: 'Zum Video',
  BILLING_VIDEO_TEXT:
    'Mit einem Video erläutern wir Ihnen schnell, einfach und unkompliziert die wichtigsten Punkte Ihrer Nebenkostenabrechnung.',
  BILLING_VIDEO_TEXT_1: 'Sie möchten sich Ihre Nebenkosten von uns persönlich erklären lassen?',
  BILLING_VIDEO_TEXT_2: 'Hier geht es zu Ihrem persönlichen Abrechnungsvideo.',
  BILLING_VIDEO_TEXT_3: 'Sie interessieren sich allgemein für die Zusammensetzung der Nebenkosten?',
  BILLING_VIDEO_TEXT_4: 'Schauen Sie sich unser Video zur Musterabrechnung an.',
  BK01_BANK_ACCOUNT: 'Konto für Ihre Mietzahlungen',
  CONTACT_PERSON: 'Mein Ansprechpartner',
  COPY_VALUE: '$$$ kopieren',
  DEPOSIT_ACCOUNT: 'Mein Kautionskonto',
  DEPOSIT_ACTUAL: 'Aktueller Kontostand',
  DEPOSIT_REQUIRED: 'Vereinbarte Kaution',
  DISCLAIMER_TEXT: '',
  DUNNING_BLOCK_INFO_3:
    'Bei Fragen zu Ihrem Mietkonto setzen Sie sich bitte mit dem weiter unten aufgeführten Ansprechpartner in Verbindung.',
  NO_BK01_ACCOUNT_TEXT:
    'Ihr Kautionskonto ist nicht bei der Aarealbank angelegt. Daher können Ihnen hier keine Auskünfte angezeigt werden. Bei Fragen zu Ihrem Kautionskonto setzen Sie sich bitte mit der untenstehenden Kontaktperson in Verbindung.',
  PAGE_HEADING: 'Vertragskonto',
  PAGE_SUBHEADING:
    'Alles auf einen Blick: Wie sich Ihre Miete aus Grundmiete, Betriebskosten, Heizung und Warmwasser zusammensetzt.',
  TRANSFER_INFO_TEXT:
    'Tipp: Erstellen Sie einen Screenshot dieser Zahlungsdaten und laden Sie ihn anschließend in Ihrer Banking-App hoch, um die Überweisung schnell und einfach vorzubereiten.',
  RENT_COST_GROSS: 'Netto',
  RENT_COST_TAX: 'USt. 19%',
  REQUEST_BANK_ACCOUNT_HISTORY_HEADING: 'Konto-Entwicklung ausstellen',
  REQUEST_DOCUMENT: 'Dokument anfordern',
  SEPARATE_COST_TEXT:
    'Für die Bereitstellung der Gemeinschaftsräume (Gemeinschaftsküche und -räume und Toilette im Erdgeschoss, Außenterrasse im Erdgeschoss sowie Gemeinschaftsflächen in den einzelnen Etagen, außer im 2. OG), wird eine Aufwandsentschädigung von $$$ mtl. erhoben. Diese gilt als Nettobetrag, die auf die Gemeinschaftsfläche entfallenden Betriebskosten sind hierin nicht enthalten.',
  SHOW_BANK_ACCOUNT_BALANCE: 'Kontostand einsehen',
  SHOW_BANK_ACCOUNT_HISTORY: 'Konto-Entwicklung anzeigen',
};

export const LANG_DE_CONTRACT_REQUEST_DOCUMENTS_TRANS = {
  PAGE_HEADING: 'Dokumente anfordern',
  PAGE_SUBHEADING:
    'Sie benötigen eine Mietbescheinigung oder möchten uns zum Einzug der Miete ermächtigen? Fordern Sie hier das gewünschte Dokument an.',
  REQUEST_CONFIRMATION_DOCUMENTS: 'Dokument anfordern',
  REQUEST_CONFIRMATION_DOCUMENTS_TEXT:
    'Wir kümmern uns um Ihr Anliegen. Sobald Ihr Objektbetreuer das Dokument ausgestellt hat, können Sie es im Bereich „Meine Dokumente“ ansehen und herunterladen.',
  REQUEST_CONFIRMATION_DOCUMENTS_AUTO: 'Dokument anfordern',
  REQUEST_CONFIRMATION_DOCUMENTS_AUTO_TEXT:
    'Mit der Bestätigung Ihres Anliegens wird das gewünschte Dokument ausgestellt. Dieses steht Ihnen im Bereich „Meine Dokumente“ zum Download zur Verfügung.',
};

export const LANG_DE_CONTRACT_BANK_ACCOUNT_BALANCE_TRANS = {
  AMOUNT_TO_PAY: 'zur Zahlung fällig',
  AMOUNT_TO_PAY_DISCLAIMER:
    'Wir weisen darauf hin, dass bei Zahlungen, die ohne Zweckbestimmung geleistet werden, der § 366 BGB Anwendung findet.',
  BALANCE: 'Zur Zahlung fällig',
  BALANCE_COMPLETE: 'Gesamtsaldo',
  DUE_TO: 'Fälligkeit',
  NO_BANK_ACCOUNT_BALANCE_HEADING: 'Keine offenen Posten',
  NO_BANK_ACCOUNT_BALANCE_TEXT: 'Zu Ihrem ausgewählten Mietvertrag konnten keine offenen Posten gefunden werden.',
  NOT_DUE_INFO_TEXT: 'Ausgegraute Beträge sind derzeit nicht zur Zahlung fällig.',
  OPEN_ITEMS: 'Offene Posten',
  PAGE_HEADING: 'Mein Kontostand',
  PAGE_SUBHEADING: 'In der Übersicht sehen Sie das Saldo der offenen Posten Ihres Mietkontos.',
  SHOW_BANK_ACCOUNT_HISTORY: 'Konto-Entwicklung anzeigen',
  TOTAL: 'Gesamtsaldo',
};

export const LANG_DE_ISSUES_TRANS = {
  HELP_US_TO_IMPROVE: 'Helfen Sie uns besser zu werden!',
  YOUR_ISSUE: 'Ihr Anliegen',
  YOUR_COMMENTS: 'Ihre Angaben',
  WAS_CLOSED: 'wurde abgeschlossen',
  EVALUATE_NOW: 'Jetzt bewerten!',
  EVALUATE_REPAIR: 'Reparatur bewerten',
  PAGE_HEADING: 'Ihre Fragen an uns. Sind noch Wünsche offen?',
  PAGE_SUBHEADING: 'Schadensmeldungen, Aufträge und Anträge im Blick: Erfahren Sie den aktuellen Stand Ihrer Anfragen.',
};

export const LANG_DE_ISSUE_DETAILS_TRANS = {
  ASK_DEMAND: 'Anmerkung hinzufügen',
  ADD_NOTES_TO_NOTIFICATION_BUTTON: 'Anmerkung hinzufügen',
  CALENDAR_EVENT_LABEL: 'Termin zur Schadensbehebung',
  CANCEL_NOTIFICATION_BUTTON: 'Meldung stornieren',
  CHANGE_APPOINTMENT_BUTTON: 'Termin ändern',
  CREATED_AT: 'erstellt am',
  DEMAND: 'Nachträgliche Anmerkung',
  DEMAND_COMMENT: 'Rückfrage/Anmerkung',
  GO_TO_CHAT: 'Zum Dialog',
  NOTIFICATION_CANCELLATION_BUTTON_TEXT: 'Stornieren',
  ISSUE_DEMAND_DIALOG_HEADING: 'Sind noch Fragen offen?',
  ISSUE_DEMAND_DIALOG_SUBHEADING:
    'Sie haben eine Rückfrage oder eine Anmerkung zu Ihrem gemeldeten Anliegen? Schreiben Sie uns, wir kümmern uns umgehend darum.',
  ISSUE_DESCRIPTION: 'Meldungsbeschreibung',
  START_CHAT: 'Dialog starten',
  RETURN_MESSAGE: 'Rückmeldung',
  YOUR_COMMENTS: 'Ihre Angaben',
  STORNO_TITLE: 'Meldung stornieren/ zurückziehen',
  TENANT_SURVEY_DEFAULT_TITLE: 'Hauswart Mieterbefragung',
};

export const LANG_DE_MARKETPLACE_TRANS = {
  DEAL_OF_THE_MONTH: 'Deal des Monats',
  EXPLANATION_HEADING: 'Was ist die Datatrain Marketplace und was erwartet sie hier.',
  EXPLANATION_TEXT_1:
    'Die Datatrain Marketplace ist eine Plattform, auf der Sie exklusive Angebote und Rabatte von unseren Partnern finden können. Wir arbeiten kontinuierlich daran, Ihnen attraktive Deals zu präsentieren, die Ihren Alltag bereichern und Ihnen dabei helfen, Geld zu sparen.',
  EXPLANATION_TEXT_2: '',
  OFFERS_HEADING: 'Unsere Partnerangebote',
  OFFERS_SUBHEADING: 'Hier finden Sie aktuelle Angebote unserer Partner.',
  OFFER_DETAILS_DEAL_BADGE: 'Deal des Monats 1--31.03.2025',
  OFFER_DETAILS_HERO_CTA: 'Gutschein einlösen',
  OFFER_DETAILS_LOCATION_BADGE: 'Berlin',
  OFFER_DETAILS_PARTNER_HEADING: 'Über den Partner',
  OFFER_DETAILS_SUBHEADING: 'Vorteilswelt-Angebot',
  OFFER_RATING_HEADING: 'Wie gefällt Ihnen dieses Angebot?',
  OFFER_RATING_ARIA_SUFFIX: 'von 5',
  OFFER_RATING_SUCCESS: 'Vielen Dank für Ihre Bewertung!',
  BACK_TO_OFFERS_OVERVIEW: 'Zur Angebotsübersicht',
  RELATED_OFFERS_HEADING: 'Weitere Angebote aus der Gewobag Vorteilswelt',
  RELATED_OFFERS_LINK: 'Alle Angebote',
  PAGE_HEADING: 'Datatrain Marketplace',
  PAGE_SUBHEADING: 'Ihre Datatrain Marketplace',
  REDEEM_NOW: 'Jetzt einlösen',
  SHARE_EMAIL: 'E-Mail',
  SHARE_OFFER: 'Angebot weiterempfehlen',
  SHARE_POPOVER_COPY_LINK: 'Link kopieren',
  SHARE_POPOVER_LINK: 'Link zum Angebot',
  SHARE_POPOVER_LINK_COPIED: 'Link kopiert',
  SHARE_WHATSAPP: 'WhatsApp',
  INPUT_TEXT: '',
  SUBSCRIBE_CTA: '',
  SUBSCRIPTION_CONSENT: '',
  SUBSCRIPTION_ERROR: 'Die Anmeldung konnte gerade nicht abgeschlossen werden. Bitte versuchen Sie es erneut.',
  SUBSCRIPTION_HEADING: '',
  SUBSCRIPTION_PROMPT: '',
  SUBSCRIPTION_OFFER: '',
  SUBSCRIPTION_SUCCESS_CTA: 'Zu den Angeboten',
  SUBSCRIPTION_SUCCESS_INLINE_MESSAGE:
    'Vielen Dank für Ihre Anmeldung zum Newsletter. Wir haben Ihnen eine E-Mail an die angegebene Adresse geschickt. Bitte bestätigen Sie Ihre Anmeldung.',
  NOTIFICATION_CONSENT_TITLE: 'Benachrichtigungen aktivieren',
  NOTIFICATION_CONSENT_DESCRIPTION:
    'Bleiben Sie bei neuen Angeboten immer auf dem neuesten Stand. Wählen Sie aus, über welche Kanäle wir Sie informieren dürfen.',
  NOTIFICATION_CONSENT_CTA: 'Speichern',
  NOTIFICATION_CONSENT_ERROR: 'Die Einwilligungen konnten gerade nicht geladen werden. Bitte versuchen Sie es erneut.',
  NOTIFICATION_CONSENT_LOADING: 'Einwilligungen werden geladen.',
  NOTIFICATION_CONSENT_NO_OPTIONS: 'Für Angebote stehen aktuell keine Benachrichtigungsoptionen zur Verfügung.',
  NOTIFICATION_CONSENT_PRIVACY: 'Infos zum Datenschutz',
  NOTIFICATION_CONSENT_SAVE_ERROR:
    'Die Einwilligungen konnten gerade nicht gespeichert werden. Bitte versuchen Sie es erneut.',
  SUBSCRIPTION_SUCCESS_MESSAGE: 'Wir freuen uns, dass Sie sich für unseren Newsletter angemeldet haben.',
  SUBSCRIPTION_SUCCESS_TITLE: 'Willkommen beim Newsletter',
  TO_OFFER: 'Zum Angebot',
  FAQ_HEADING: 'FAQ',
  FILTER_ALL: 'Alle',
};

export const LANG_DE_NEWS_TRANS = {
  PAGE_HEADING: 'Aktuelles',
  PAGE_SUBHEADING: 'Hier gibt es den Newsfeed.',
};

export const LANG_DE_START_TRANS = {
  NO_CONTRACT_CONNECTED_HEADING: 'Keine Mietverträge verknüpft',
  NO_CONTRACT_CONNECTED_TEXT: 'Wenn Sie Mieter sind, können Sie hier mieterspezifische Funktionen freischalten.',
  NO_CONTRACT_CONNECTED_LINK: 'Mietvertrag verknüpfen',
  PAGE_HEADING: 'Was können wir für Sie tun?',
  PAGE_SUBHEADING:
    'Für Ihre Zufriedenheit setzen wir alles in Bewegung. Nutzen Sie unsere neue App, um aktuelle Informationen zu erhalten und uns Ihre Anliegen mitzuteilen.',
  USER_ACTIVATION_HEADING: 'Schalten Sie alle Funktionen frei',
  USER_ACTIVATION_TEXT:
    'Damit Sie alle Funktionen des Kundenportals nutzen können, benötigen Sie Ihren Code, den wir Ihnen im Zuge Ihrer Registrierung per Post zugesendet haben.',
  USER_ACTIVATION_LINK: 'Aktivierungscode eingeben',
  WELCOME: 'Herzlich willkommen,',
  WELCOME_AFTER_USERNAME: '',
};

export const LANG_DE_SURVEY_TRANS = {
  PREMATURELY_FINISH_SURVEY: 'Befragung vorzeitig abschließen',
  PREMATURELY_FINISH_SURVEY_TEXT:
    'Sie haben noch nicht alle Fragen beantwortet. Möchten Sie die Befragung trotzdem abschließen?',
  SURVEY_COMPLETED_HEADER: 'Danke für Ihre Unterstützung',
  SURVEY_COMPLETED_TEXT: 'Ihr Feedback trägt dazu bei, unsere Prozesse zu verbessern.',
};

export const LANG_DE_REGISTRATION_TRANS = {
  DISCLAIMER_TEXT:
    'Mit meiner Registrierung stimme ich den Nutzungsbedingungen und der Datenschutzrichtlinien der Datatrain GmbH zu.',
  DOORS_SUBHEADING: 'Wir prüfen, ob für Sie digitale Türzugänge verfügbar sind.',
  DOORS_AVAILABLE_BLANKSLATE_HEADING: 'Digitale Türzugänge gefunden',
  DOORS_AVAILABLE_BLANKSLATE_TEXT: 'Verwalten Sie Ihre digitalen Türzugänge unter "Meine Türen".',
  DOORS_NOT_AVAILABLE_BLANKSLATE_HEADING: 'Keine digitalen Türzugänge vorhanden',
  DOORS_NOT_AVAILABLE_BLANKSLATE_TEXT:
    'Sobald digitale Türzugänge für Sie verfügbar sind, stehen Ihnen diese unter "Meine Türen" zur Verfügung.',
  IDENTIFICATION_SUCCESSFUL: 'Identifikation erfolgreich',
  IDENTIFICATION_SUCCESSFUL_TEXT:
    'Wir haben Sie erfolgreich als Mieter in unserem System identifiziert. Sie können mit der Registrierung fortfahren.',
  PAGE_HEADING: 'Registrieren',
  PAGE_SUBHEADING: 'Im Rahmen der Registrierung benötigen wir zunächst Angaben, um Sie als Mieter zu identifizieren.',
  PROVIDE_SECURE_PASSWORD:
    'Bitte geben Sie Ihre E-Mail-Adresse als Benutzername ein und wählen Sie ein sicheres Kennwort.',
  REGISTRATION_COMPLETE_HEADING: 'Ihre Registrierung war erfolgreich',
  REGISTRATION_COMPLETE_TEXT:
    'Damit Ihnen alle Funktionen dieses Mietercockpits uneingeschränkt zur Verfügung stehen, bestätigen Sie bitte den Link, den wir an Ihre E-Mail-Adresse geschickt haben.',
  REGISTRATION_FAILED: 'Entschuldigung, da ist etwas schiefgegangen ...',
  REGISTRATION_FAILED_HEADING: 'Registrierung nicht möglich',
  REGISTRATION_FAILED_TEXT:
    'Leider konnten wir Ihre Daten nicht bestätigen. Bitte nehmen Sie mit uns Kontakt auf. Vielen Dank.',
  START_APPLICATION: 'Anmelden',
  SUBMIT_REGISTRATION: 'Registrierung abschließen',
  SUBMIT_IDENTIFICATION: 'Informationen absenden',
};

export const LANG_DE_REGISTRATION_CREATEACCOUNT_TRANS = {
  PAGE_HEADING: 'Benutzerkonto erstellen',
  PAGE_SUBHEADING: '',
  CREATE_ACCOUNT: 'Benutzerkonto erstellen',
};

export const LANG_DE_REGISTRATION_COMPLETED_TRANS = {
  PAGE_HEADING: 'Vielen Dank für Ihre Registrierung',
  PAGE_SUBHEADING: 'Bitte bestätigen Sie den Link, den wir an Ihre E-Mail-Adresse geschickt haben.',
};

export const LANG_DE_PUBLIC_WELCOME_TRANS = {
  CONNECT_CONTRACT: 'Mietvertrag verknüpfen',
  DISCLAIMER_TEXT: 'Sie können die Freischaltung auch zu einem späteren Zeitpunkt durchführen.',
  PAGE_HEADING: 'Sind Sie Mieter?',
  PAGE_DESCRIPTION:
    'Um alle Funktionen des Mietercockpits nutzen zu können, benötigen Sie einen gültigen Mietvertrag bei der Datatrain. Bitte halten Sie Ihre Vertragsdaten bereit.',
  WITHOUT_CONTRACT: 'Weiter ohne Mietvertrag',
};

export const LANG_DE_PUBLIC_CONNECTCONTRACT_TRANS = {
  CONTRACT_TYPE_SELECTION_LABEL: 'Bitte wählen Sie den Vertragtyp aus',
  COMPANY_CONTRACT_LABEL: 'Gewerbe',
  NO_CONTRACT_DATA: 'Keine Mietvertragsdaten?',
  NO_CONTRACT_DATA_TEXT:
    'Geben Sie Ihre Daten ein und wir ermitteln Ihre Vertragsdaten. Nachdem wir Sie als Mieter identifiziert haben, schicken wir Ihnen einen Code per Post zu.',
  PAGE_HEADING: 'Mietvertrag verknüpfen',
  PAGE_SUBHEADING: '',
  PAGE_HEADING_ALTERNATIVE: 'Verknüpfung über Adressdaten',
  PAGE_DESCRIPTION_ALTERNATIVE:
    'Bitte teilen Sie uns die Adressdaten zu Ihrem Mietverhältnis mit, damit wir Sie als Mieter identifizieren können.',
  PAGE_DESCRIPTION_ALTERNATIVE_FORCED:
    'Leider konnten wir Sie über die Mietvertragsdaten nicht identifizieren. Bitte teilen Sie uns die Adressdaten zu Ihrem Mietverhältnis mit, damit wir Sie als Mieter identifizieren können.',
  PERSON_CONTRACT_LABEL: 'Privatperson',
  PIN_REQUESTED_HEADING: 'Aktivierungscode wurde angefordert',
  PIN_REQUESTED_DESCRIPTION: 'Sie erhalten Ihren Aktivierungscode per Post',
  REQUEST_PIN: 'Aktivierungscode anfordern',
  USE_ALTERNATIVE: 'Adressdaten eingeben',
  USE_CONTRACT_DATA: 'Zurück zu Vertragsdaten',
};

export const LANG_DE_PUBLIC_CONNECTCONTRACTFAILED_TRANS = {
  PAGE_HEADING: 'Verknüpfung nicht erfolgreich',
  PAGE_DESCRIPTION:
    'Tut uns leid, wir konnten Sie leider nicht als Mieter identifizieren. Bitte wenden Sie sich an unser Kundencenter.',
};

export const LANG_DE_PUBLIC_REQUESTPIN_TRANS = {
  PAGE_HEADING: 'Aktivierungscode anfordern',
  PAGE_DESCRIPTION:
    'Bitte teilen Sie uns Ihre persönlichen Daten zu Ihrem Mietverhältnis mit, damit wir Sie als Mieter identifizieren können.',
};

export const LANG_DE_PUBLIC_ENTERPIN_TRANS = {
  AT: 'um',
  NEW_PIN_REQUESTED: 'Wir haben Ihre Anfrage erhalten und werden Ihnen einen neuen Einmalcode per Post zusenden.',
  PAGE_HEADING: 'Aktivierungscode eingeben',
  PAGE_DESCRIPTION: 'Geben Sie hier Ihren Aktivierungscode ein, den wir Ihnen per Post zugesandt haben.',
  PIN_EXPIRED_INFO_TEXT1: 'Sie können nach Ablauf von',
  PIN_EXPIRED_INFO_TEXT2:
    'Stunden einen neuen Code anfordern. Dieser wird Ihnen dann per Post zugesandt. Bitte beachten Sie, dass die Zusendung des Codes einige Tage in Anspruch nehmen kann.',
  PIN_NOT_VALID: 'Der von Ihnen eingegebene Code ist ungültig.',
  PIN_REQUEST_DATE_TEXT: 'Ihr Einmalcode wurde angefordert am',
  PIN_QUESTION_TITLES: 'Fragen oder Probleme?',
  PROBLEMS_INFO_TEXT: 'Sie können sich nicht verifizieren oder haben Fragen zu dem Verifizierungsvorgang?',
  PROBLEMS_LINK: 'Wir helfen gerne weiter',
  REQUEST_PIN: 'Einmalcode erneut anfordern',
  VERIFY_PIN: 'Code verifizieren',
};

export const LANG_DE_PUBLIC_USERREJECTED_TRANS = {
  PAGE_HEADING: 'Verknüpfung nicht erfolgreich',
  PAGE_DESCRIPTION:
    'Tut uns leid, wir konnten Sie leider nicht als Mieter identifizieren. Bitte teilen Sie uns Ihre persönlichen Daten zu Ihrem Mietverhältnis mit, damit wir Sie als Mieter identifizieren können.',
};

export const LANG_DE_LOGINWITHOUTREGISTRATION_CONNECTCONTRACT_TRANS = {
  COMPANY: 'Gewerbe',
  ERROR_NAME_TITLE: 'Vorname/Nachname',
  ERROR_NAME_DESCRIPTION1: 'Bitte nur Ihren Namen und keine weiteren Mieter eintragen.',
  ERROR_NAME_DESCRIPTION2: 'Bitte geben Sie Ihren Vornamen (ggf. mehrere) gemäß eines unserer Anschreiben an.',
  ERROR_NAME_DESCRIPTION3: 'Bitte geben Sie keine akademischen Titel an.',
  ERROR_CONTRACTNR_TITLE: 'Mietvertragsnummer',
  ERROR_CONTRACTNR_DESCRIPTION1:
    'Verwenden Sie bitte Ihre aktuelle Mietvertragsnummer. Diese können Sie in einem unserer letzten Anschreiben finden.',
  ERROR_BUSINESS_NAME1_TITLE: 'Firmenname bzw. Vorname',
  ERROR_BUSINESS_NAME1_DESCRIPTION1:
    'Bitte geben Sie Ihren Firmennamen bzw. Ihren Vornamen (ggf. mehrere) gemäß Zeile 1 eines unserer Anschreiben an.',
  ERROR_BUSINESS_NAME1_DESCRIPTION2: 'Bitte geben Sie keine akademischen Titel an.',
  ERROR_BUSINESS_NAME2_TITLE: 'Zusatz bzw. Nachname',
  ERROR_BUSINESS_NAME2_DESCRIPTION1:
    'Bitte geben Sie den zweiten Teil Ihres Firmennamens bzw. Ihren Nachnamen gemäß Zeile 2 eines unserer Anschreiben an, sofern zutreffend (ggf. keine Angabe).',
  NO_CONTRACT_DATA: 'Keine Mietvertragsdaten?',
  NO_CONTRACT_DATA_TEXT:
    'Geben Sie Ihre Daten ein und wir ermitteln Ihre Vertragsdaten. Nachdem wir Sie als Mieter identifiziert haben, schicken wir Ihnen einen Code per Post zu.',
  PAGE_HEADING: 'Registrieren',
  PAGE_SUBHEADING: 'Im Rahmen der Registrierung benötigen wir zunächst Angaben, um Sie als Mieter zu identifizieren.',
  PAGE_SUBHEADING_ERROR:
    'Es gab einen Fehler bei der Registrierung. Bitte überprüfen und korrigieren Sie Ihre Angaben. Hinweis zu häufigen Fehlern:',
  PERSON: 'Privatperson',
  REQUEST_PIN: 'Aktivierungscode anfordern',
  TOO_MANY_ATTEMPTS:
    'Ihre Daten werden überprüft. Dieser Prozess dauert im Normalfall 2 Werktage. Sie werden über den Ausgang der Prüfung informiert. Bis dahin ist eine erneute Registrierung leider nicht möglich.',
  TOO_MANY_ATTEMPTS_HEADING: 'Verknüpfung nicht erfolgreich',
  TOO_MANY_ATTEMPTS_DESCRIPTION:
    'Tut uns leid, wir konnten Sie leider nicht als Mieter identifizieren. Bitte teilen Sie uns Ihre persönlichen Daten zu Ihrem Mietverhältnis mit, damit wir Sie als Mieter identifizieren können.',
};

export const LANG_DE_LOGINWITHOUTREGISTRATION_REQUESTPIN_TRANS = {
  PAGE_HEADING: 'Aktivierungscode anfordern',
  PAGE_DESCRIPTION:
    'Bitte teilen Sie uns Ihre persönlichen Daten zu Ihrem Mietverhältnis mit, damit wir Sie als Mieter identifizieren können.',
};

export const LANG_DE_LOGINWITHOUTREGISTRATION_PINREQUESTED_TRANS = {
  BACK: 'Zurück zur Startseite',
  PAGE_HEADING: 'Aktivierungscode wurde angefordert',
  PAGE_DESCRIPTION: 'Sie erhalten Ihren Aktivierungscode per Post',
};

export const LANG_DE_LOGINWITHOUTREGISTRATION_ENTERPIN_TRANS = {
  PAGE_HEADING: 'Aktivierungscode eingeben',
  PAGE_DESCRIPTION:
    'Geben Sie zur Aktivierung Ihres Benutzerkontos den Pin ein, den Sie von uns per Post erhalten haben.',
  REQUEST_PIN_AGAIN: 'Code erneut anfordern',
  SEND_DATA: 'Code überprüfen',
};

export const LANG_DE_LOGINWITHOUTREGISTRATION_USERREJECTED_TRANS = {
  PAGE_HEADING: 'Verknüpfung nicht erfolgreich',
  PAGE_DESCRIPTION:
    'Tut uns leid, wir konnten Sie leider nicht als Mieter identifizieren. Bitte wenden Sie sich an unser Kundencenter.',
};

export const LANG_DE_REQUESTPASSWORD_TRANS = {
  BACK_TO_LOGIN: 'Zurück zur Anmeldung',
  PAGE_HEADING: 'Kennwort vergessen',
  PAGE_SUBHEADING:
    'Bitte geben Sie Ihre E-Mail-Adresse ein. Sie erhalten in Kürze eine Mail mit weiteren Anweisungen, wie Sie ein neues Kennwort anlegen können.',
  PASSWORD_REQUESTED:
    'Bitte benutzen Sie den Link, den wir an Ihre E-Mail-Adresse geschickt haben, um Ihr neues Kennwort festlegen zu können.',
  RESET_PASSWORD: 'Kennwort zurücksetzen',
};

export const LANG_DE_MIGRATION_TRANS = {
  BACK_TO_LOGIN: 'Zurück zur Anmeldung',
  PAGE_HEADING: 'Kennwort zurücksetzen',
  PAGE_SUBHEADING:
    'Bitte geben Sie Ihre E-Mail-Adresse ein, mit der Sie in dem im anderen Mietercockpit angemeldet waren.',
  PASSWORD_REQUESTED:
    'Bitte benutzen Sie den Link, den wir an Ihre E-Mail-Adresse geschickt haben, um Ihr neues Kennwort festlegen zu können.',
  RESET_PASSWORD: 'Kennwort zurücksetzen',
};

export const LANG_DE_SETPASSWORD_TRANS = {
  BACK_TO_LOGIN: 'Zurück',
  PAGE_HEADING: 'Neues Kennwort festlegen',
  PAGE_SUBHEADING:
    'Bitte geben Sie hier Ihr neues Kennwort ein und wiederholen die Angabe zur Sicherheit. Bitte achten Sie darauf, ein sicheres Kennwort zu verwenden. Dieses muss über acht alphanumerische Zeichen, einem Sonderzeichen sowie einem Großbuchstaben bestehen.',
  SAVE_PASSWORD: 'Kennwort speichern',
};

export const LANG_DE_UNLOCK_TRANS = {
  FINGERPRINT_LOCKED: 'Zu viele Versuche, bitte später erneut versuchen.',
  FINGERPRINT_LOCKED_ANDROID: 'FingerPrint durch Fehlversuche temporär gesperrt.',
  FINGERPRINT_LOCKED_IOS: 'Touch ID durch Fehlversuche gesperrt.',
  FORGOT_PASSWORD: 'Kennwort vergessen?',
  LOGIN_WITH_OTHER_ACCOUNT: 'Mit anderem Konto anmelden?',
  PAGE_HEADING: 'Entsperren',
  PAGE_SUBHEADING: 'Einfach Ihr Gerät entsperren und das Mietercockpit nutzen',
  UNLOCK_ANDROID_TITLE: 'Mietercockpit',
  UNLOCK_ANDROID_MESSAGE: 'Jetzt mit Touch im Mietercockpit anmelden',
  UNLOCK_ANDROID_HINT: 'Keiner klaut dir deine Identität',
  UNLOCK_IOS_TOUCH: 'Jetzt mit Touch ID im Mietercockpit anmelden',
  UNLOCK_WITH_BIOMETRIC: 'Entsperren Sie die Anwendung jetzt mit Ihrem Fingerabdruck',
};

export const LANG_DE_VERIFYEMAIL_TRANS = {
  PAGE_HEADING: 'E-Mail-Verifizierung',
  PAGE_SUBHEADING_LOADING: 'Wir verifizieren Ihre E-Mail-Adresse. Wir bitten um einen kleinen Augenblick Geduld',
  PAGE_SUBHEADING_OK:
    'Ihre E-Mail-Adresse wurde erfolgreich verifiziert. Viel Vergnügen bei der Nutzung des Mietercockpits.',
  PAGE_SUBHEADING_ERROR:
    'Leider ist bei der Verifizierung Ihrer E-Mailadresse ein Fehler aufgetreten. Bitte fordern Sie einen neuen Link über ihre App an.',
  BACK_TO_LOGIN: 'Zurück zur Anmeldung',
};

export const LANG_DE_SETEMAIL_TRANS = {
  PAGE_HEADING_SUCCESS: 'E-Mail-Adresse ändern',
  PAGE_HEADING_ERROR: 'E-Mail-Adresse ändern',
  PAGE_SUBHEADING_LOADING: 'Wir aktualisieren Ihre E-Mail-Adresse. Wir bitten um einen kleinen Augenblick Geduld',
  PAGE_SUBHEADING_OK: 'Ihre E-Mail-Adresse wurde erfolgreich aktualisiert.',
  PAGE_SUBHEADING_ERROR:
    'Leider ist bei der Aktualisierung Ihrer E-Mailadresse ein Fehler aufgetreten. Bitte fordern Sie einen neuen Link über ihre App an.',
  BACK_TO_LOGIN: 'Zurück zur Anmeldung',
};

export const LANG_DE_LOGOUT_TRANS = {
  ACCOUNT_DELETED_HEADING: 'Schade, dass Sie uns verlassen',
  ACCOUNT_DELETED_TEXT:
    'Wir haben alle Benutzerdaten erfolgreich aus unserem System entfernt. Falls Sie in Zukunft das Mietercockpit wieder nutzen wollen, freuen wir uns sehr. Dafür registrieren Sie sich bitte neu.',
  YOU_WERE_LOGGED_OUT: 'Sie wurden vom System abgemeldet',
  YOU_WERE_LOGGED_OUT_DESCRIPTION:
    'Es konnte kein gültiger Mietvertrag gefunden werden. Deshalb wurden Sie aus Sicherheitsgründen abgemeldet.',
};

export const LANG_DE_FAQ_TRANS = {
  FAQ: 'FAQ',
};

export const LANG_DE_DOORS_TRANS = {
  VALID_TO: 'Gültig Bis',
  VALID_TO_SMALL: 'gültig bis: ',
  SHARED_DOOR_HEADING: 'Tür teilen',
  SHARED_DOOR_SUBHEADING: 'Geben Sie einem Freund temporären Zugriff zu Ihren Türen',
  REMOVE_SHARED_DOOR: 'Türzugang entziehen',
  SEND_SHARED_DOOR: 'Tür versenden',
  COPY_TO_CLIPBOARD: 'Link teilen',
  SHARE_DOOR: 'Türzugänge teilen',
  OPEN_DOOR: 'Tür öffnen',
  DOOR_OPENED: 'Tür wurde geöffnet',
  DOOR_OPENER: 'Türöffner',
  DETAILS_DOOR: 'Angaben zur Tür',
  SHARED_DOORS: 'Geteilte Türen',
  SHARED_STATUS: 'Share completed?',
  SHARED_TO_APP: 'Shared to app: ',
  SHARING_FAILED: 'Sharing failed with message: ',
  PAGE_HEADING: 'Sesam öffne dich!',
  PAGE_SUBHEADING:
    'Hier haben Sie einen Überblick über Ihre digitalen Türzugänge. Wählen Sie die gewünschte Tür aus und öffnen Sie diese aus Ihrer App heraus.',
  SHARE_DOOR_SUCCESS: 'Die Berechtigung wurde versandt.',
  SHARE_DOOR_FAIL:
    'Die Berechtigung konnte nicht versendet werden. Prüfen Sie bitte die eingegebene E-Mail-Adresse des Empfängers.',
  SHARE_DOOR_REMOVE: 'Die Berechtigung wurde entfernt.',
  SHARING_SUCCESS:
    'Sie haben Ihre Tür freigegeben. Die Freigabe endet automatisch nach Ablauf des Gültigkeitszeitraums.',
  PERMISSION_TO: 'Zugang zu ',
  RECEIVER_MAIL: 'Empfänger E-Mail',
};

export const LANG_DE_MOBILITY_STATION_TRANS = {
  PAGE_HEADING: 'Mobilitätsstation',
  PAGE_SUBHEADING:
    'Sie haben als Mieter*In künftig die Möglichkeit, eine Mobilitätsstation in Ihrem Haus zu nutzen. Mit den folgenden Schritten können Sie sich dafür anmelden:',
};

export const LANG_DE_ERROR_TRANS = {
  SYSTEM_NOT_AVAILABLE_HEADER: 'System nicht erreichbar',
  SERVICE_NOT_AVAILABLE_TEXT1: 'Aufgrund von Wartungsarbeiten ist die App leider vorübergehend nicht erreichbar.',
  SERVICE_NOT_AVAILABLE_TEXT2:
    'In dringenden Fällen erreichen Sie uns telefonisch unter <a href="tel:+4930600500400">030 600 500 400</a>.',
  SERVICE_NOT_AVAILABLE_TEXT3: 'Vielen Dank für Ihr Verständnis.',
};

export const LANG_DE_DOWNLOAD_DOCUMENTS_TRANS = {
  ERROR_HEADING: 'Download fehlgeschlagen',
  ERROR_MESSAGE:
    'Beim Download des Dokuments ist ein Fehler aufgetreten. Bitte versuchen Sie es zu einem späteren Zeitpunkt noch einmal.',
  PAGE_HEADING: 'Download gestartet',
  PAGE_MESSAGE: 'Der Download wurde erfolgreich gestartet. Bitte warten Sie, bis der Download abgeschlossen ist.',
};

export const LANG_DE_DOCUMENTS_TRANS = {
  PAGE_HEADING: 'Alle Unterlagen zur Hand',
  PAGE_SUBHEADING: 'Hier können Sie Dokumente anfordern, einsehen oder erfahren den aktuellen Stand Ihrer Anfrage.',
  CREATED_AT: 'erstellt am',
  VALID_TO: 'gültig bis',
  REQUEST_NEW_DOCUMENT: 'Neues Dokument anfordern',
  VALID_TILL_1: 'Das Dokument steht bis ',
  VALID_TILL_2: 'zum Download bereit.',
};

export const LANG_DE_PIN_TRANS = {
  AT: 'um',
  NEW_PIN_REQUESTED: 'Wir haben Ihre Anfrage erhalten und werden Ihnen einen neuen Einmalcode per Post zusenden.',
  PAGE_HEADING: 'Verifizierung',
  PAGE_SUBHEADING: 'Bitte geben Sie hier den sechsstelligen Einmalcode ein, den wir Ihnen per Post zugesandt haben.',
  PIN_EXPIRED_INFO_TEXT:
    'Sie können nach Ablauf von 72 Stunden einen neuen Code anfordern. Dieser wird Ihnen das per Post zugesandt. Bitte beachten Sie, dass die Zusendung des Codes einige Tage in Anspruch nehmen kann.',
  PIN_NOT_VALID: 'Der von Ihnen eingegebene Code ist ungültig.',
  PIN_REQUEST_DATE_TEXT: 'Ihr Einmalcode wurde angefordert am',
  PIN_QUESTION_TITLES: 'Fragen oder Probleme?',
  PROBLEMS_INFO_TEXT: 'Sie können sich nicht verifizieren oder haben Fragen zu dem Verifizierungsvorgang?',
  PROBLEMS_LINK: 'Wir helfen gerne weiter',
  REQUEST_PIN: 'Einmalcode erneut anfordern',
  VERIFY_PIN: 'Code verifizieren',
};

export const LANG_DE_COMPARE_EMAIL_TRANS = {
  PAGE_HEADING: 'Abgleich der E-Mail-Adressen',
  PAGE_SUBHEADING:
    'In unserem System zur Verwaltung Ihrer Mieterdaten ist eine andere E-Mail-Adresse eingetragen, als Sie für die Nutzung des Kundenportals angegeben haben. Soll die E-Mail-Adresse zur Nutzung des Kundenportals auch für die zukünftige Kontaktaufnahme für vertragsrelevante Themen mit Ihnen genutzt werden?',
  TENANT_EMAIL_TEXT: 'In unserem System zur Verwaltung Ihrer Mieterdaten hinterlegte E-Mail-Adresse',
  USER_EMAIL_TEXT: 'Für die Nutzung des Portals angegebene E-Mail-Adresse',
  CHANGE_EMAIL: 'E-Mail-Adresse ersetzen',
  KEEP_EMAIL: 'Beide E-Mail-Adressen nutzen',
  CHANGE_QUESTION:
    'Soll die für diese Anwendung registrierte E-Mail-Adresse in unserem System für Ihre Kontaktdaten übernommen werden?',
};

export const LANG_DE_CHAT_TRANS = {
  CHAT_PERMISSIONS: 'Schreibrechte',
  CHAT_MESSAGE_SEND_FAILED: 'Fehlgeschlagen',
  CHANGE_PERMISSIONS_TITLE_CONFIRMATION_DIALOG: 'Schreibrechte im Chat',
  DISABLING_PERMISSIONS_DESCRIPTION_CONFIRMATION_DIALOG:
    'Möchten Sie den Chat Schreibberechtigung auf sich beschränken?',
  ENABLING_PERMISSIONS_DESCRIPTION_CONFIRMATION_DIALOG:
    'Möchten Sie die Schreibberechtigung im Chat für alle freigeben?',
  DISABLING_PERMISSIONS_BUTTON_TEXT: 'Chat beschränken',
  ENABLING_PERMISSIONS_BUTTON_TEXT: 'Chat freigeben',
  INPUT_DISABLED_TEXT:
    'Die Bearbeitung Ihres Anliegens, das zu diesem Dialog gehört, wurde abgeschlossen. Daher können hier von Ihnen und Ihrem Gesprächspartner keine weiteren Informationen bereit gestellt werden.',
  PAGE_HEADING: 'Meine Nachrichten',
  PAGE_SUBHEADING: 'Hier finden Sie Ihre aktuellen und abgeschlossenen Dialoge.',
  NOT_READ_MESSAGES: 'Ungelesen',
  TEXT_MARKUP_TITLE:
    'Vielen Dank für Ihre Nachricht! Wir bearbeiten Ihr Anliegen so schnell wie möglich. Bitte beachten Sie, dass dies kein Echtzeit-Service ist. Vielen Dank für Ihr Verständnis!',
  TO_NOTIFICATION_BUTTON_TEXT: 'Zum Anliegen',
  MAX_NUMBER_OF_FILES_EXCEEDED: 'Sie haben schon die maximale Anzahl(5) an Dateien angehängt.',
  FILE_IS_DUPLICATE: 'Die Datei wurde bereits angehängt.',
  OF: '/',
  CHARACTERS: '',
};

export const LANG_DE_LPA_START_TRANS = {
  LOADING_TITLE: 'Daten werden geladen',
  LOADING_DESCRIPTION: 'Ihre Daten werden geladen. Bitte haben Sie einen Moment Geduld.',
  LOGIN_WITH: 'Login mit',
  LPA_PAGE_TITLE: 'Low-Permission-Access',
  PAGE_HEADER: 'Willkommen bei der ',
  PAGE_SUBHEADER: 'Bitte nutzen Sie Ihr bevorzugtes Anmeldeverfahren, um Ihre Identität zu bestätigen.',
  PAGE_SUBHEADER_SINGLE: 'Bitte melden Sie sich an, um Ihre Identität zu bestätigen.',
  OPTION_CONTRACTNUMBER_TITLE: 'Per Mietvertragsnummer',
  OPTION_CONTRACTNUMBER_DESCRIPTION:
    'Authentifizieren Sie sich als Datatrain-Mieter:in mit Ihrer Mietvertragsnummer. Sie finden diese auf dem Anschreiben oder Ihrem Mietvertrag.',
  OPTION_DATE_BIRTHDATE_TITLE: 'Per Geburtsdatum',
  OPTION_DATE_BIRTHDATE_DESCRIPTION: 'Authentifizieren Sie sich als Datatrain-Mieter:in mit Ihrem Geburtsdatum.',
  OPTION_DATE_CONTRACTBEGINDATE_TITLE: 'Per Mietvertragsbeginndatum',
  OPTION_DATE_CONTRACTBEGINDATE_DESCRIPTION:
    'Authentifizieren Sie sich als Datatrain-Mieter:in mit dem Datum Ihres Mietvertragsbeginns.',
  OPTION_IDP_TITLE: 'Benutzerkonto',
  OPTION_IDP_DESCRIPTION: 'Melden Sie sich mit Ihrem Datatrain-Konto an.',
  OPTION_PIN_EMAIL_TITLE: 'E-Mail-PIN',
  OPTION_PIN_EMAIL_DESCRIPTION:
    'Lassen Sie sich eine PIN an Ihre bei uns hinterlegte E-Mail-Adresse senden. Geben Sie dann die PIN ein.',
  OPTION_PIN_EMAIL_SUBHEADER: 'Ihre E-Mail-Adresse',
  OPTION_PIN_EMAIL_BUTTON_TEXT: 'E-Mail-PIN senden',
  'OPTION_PIN_EMAIL_BUTTON_TEXT_#ARIA': 'Mit eingegebener Email Pin anmelden',
  OPTION_PIN_PHONE_TITLE: 'SMS-PIN',
  OPTION_PIN_PHONE_DESCRIPTION:
    'Lassen Sie sich eine PIN an Ihre bei uns hinterlegte Mobilfunknummer senden. Geben Sie dann die PIN ein.',
  OPTION_PIN_PHONE_SUBHEADER: 'Ihre Mobilfunknummer',
  OPTION_PIN_PHONE_BUTTON_TEXT: 'SMS-PIN senden',
  'OPTION_PIN_PHONE_BUTTON_TEXT_#ARIA': 'Mit eingegebener Mobile Pin anmelden',
  SECTION_MAIN_HEADER: 'In der Mietercockpit App',
  SECTION_MAIN_MESSAGE:
    'Aktualisieren Sie Ihre Kontaktdaten und -einstellungen einfach im Kundenkonto Ihrer Mietercockpit-App.',
  SECTION_TILES_HEADER: 'Weitere Login-Optionen',
  SECTION_TILES_SUBHEADER: 'Oder nutzen Sie eine andere Anmeldemöglichkeit.',
  SERVICE_APP_LINK: 'https://developer.android.com/training/app-links/deep-linking',
};

export const LANG_DE_LPA_PIN_TRANS = {
  PAGE_HEADER: 'Willkommen bei der ',
  PAGE_SUBHEADER: 'Bitte bestätigen Sie, dass Sie es sind.',
  SECTION_MAIN_BUTTON: 'Anmelden',
  'SECTION_MAIN_BUTTON_#ARIA': 'Mit eingegebener Email Pin anmelden',
  SECTION_MAIN_EMAIL_PIN: 'Bitte E-Mail-PIN eingeben',
  SECTION_PIN_EMAIL_SUBHEADER: 'Ihre E-Mail-Adresse',
  SECTION_PIN_EMAIL_HEADER: 'E-Mail-PIN unterwegs',
  SECTION_PIN_EMAIL_HEADER_LANDING: 'Login mit einer E-Mail-PIN',
  SECTION_PIN_EMAIL_MESSAGE: 'Wir haben Ihnen eine PIN an die folgende E-Mail-Adresse gesendet:',
  SECTION_PIN_EMAIL_MESSAGE_LANDING: 'Lassen Sie sich eine PIN an Ihre bei uns hinterlegte E-Mail-Adresse senden.',
  SECTION_MAIN_EMAIL_SUBMESSAGE: 'Keine E-Mail erhalten? Bitte schauen Sie auch im Spam-Ordner nach.',
  SECTION_MAIN_PHONE_PIN: 'Bitte SMS-PIN eingeben',
  SECTION_PIN_PHONE_SUBHEADER: 'Ihre Mobilfunknummer',
  SECTION_PIN_PHONE_HEADER: 'Login mit einer SMS-PIN',
  SECTION_PIN_PHONE_MESSAGE:
    'Falls Ihre hinterlegte Mobilfunknummer nicht mehr aktuell ist, authentifizieren Sie sich bitte über Ihre Mietvertragsnummer.',
  SECTION_MAIN_PHONE_SUBMESSAGE:
    'Falls ihre hinterlegte Mobilfunknummer nicht mehr aktuell ist, authentifizieren Sie sich bitte über Ihre Mietvertragsnummer.',
  SECTION_MAIN_BUTTON_RESEND: 'Erneut senden',
  'SECTION_MAIN_BUTTON_RESEND_#ARIA': 'Email Pin erneut senden',
  SECTION_MAIN_BUTTON_BACK: 'Zurück',
  'SECTION_MAIN_BUTTON_BACK_#ARIA': 'Zurück zur Startseite',
  INVALID_INPUT: 'Der PIN muss aus vier Zahlen bestehen',
};

export const LANG_DE_LPA_CONTRACTNUMBER_TRANS = {
  PAGE_HEADER: 'Willkommen beim Low-Permission-Access',
  PAGE_SUBHEADER: 'Verifizier dich mit der Mievertragsnummer und lass dich überraschen',
  SECTION_MAIN_HEADER: 'Bitte geben Sie Ihre Mietvertragsnummer ein!',
  SECTION_MAIN_MESSAGE: 'Ihre Mietvertragsnummer finden Sie auf Ihrem Mietvertrag oder einer Betriebskostenabrechnung.',
  SECTION_MAIN_LANDING_HEADER: 'Login mit Ihrer Mietvertragsnummer',
  SECTION_MAIN_LANDING_MESSAGE:
    'Authentifizieren Sie sich als Datatrain-Mieter:in mit Ihrer Mietvertragsnummer. Sie finden diese auf dem Anschreiben oder Ihrem Mietvertrag.',
  SECTION_MAIN_CONTRACTNUMBER: 'Mietvertragsnummer',
  SECTION_MAIN_BUTTON: 'Weiter',
  'SECTION_MAIN_BUTTON_#ARIA': 'Mit eingegebener Vertragsnummer anmelden',
  SECTION_MAIN_BUTTON_BACK: 'Zurück',
  'SECTION_MAIN_BUTTON_BACK_#ARIA': 'Zurück zur Startseite',
  SECTION_MAIN_BUTTON_LOGIN: 'Anmelden',
  'SECTION_MAIN_BUTTON_LOGIN_#ARIA': 'Mit eingegebener Vertragsnummer anmelden',
  SECTION_MAIN_BUTTON_LANDINGPAGE: 'Mit Mietvertrag authentifizieren',
  'SECTION_MAIN_BUTTON_LANDINGPAGE_#ARIA': 'Mit eingegebenem Mietvertrag authentifizieren',
  SECTION_MAIN_BIRTHDATE: 'Geburtsdatum',
  SECTION_MAIN_CONTRACTBEGINDATE: 'Mietvertragsbeginn',
  SECTION_TILES_HEADER: 'Weitere Login-Optionen',
  SECTION_TILES_SUBHEADER: 'Oder nutzen Sie eine andere Anmeldemöglichkeit.',
  INVALID_INPUT: 'Bitte Vertragsnummer eingeben',
  INVALID_INPUT2: '',
  INVALID_DATE: 'Bitte valides Datum auswählen ',
  INVALID_DATE2: '',
};

export const LANG_DE_LPA_DATE_TRANS = {
  PAGE_HEADER: 'Willkommen beim Low-Permission-Access',
  PAGE_SUBHEADER_BIRTHDATE: 'Verifizier dich mit der Geburtsdatum und lass dich überraschen.',
  PAGE_SUBHEADER_CONTRACTBEGINDATE: 'Verifizier dich mit Ihren Vertragsbebindatum und lass dich überraschen.',
  SECTION_MAIN_HEADER_BIRTHDATE: 'Login mit Ihrem Geburtsdatum',
  SECTION_MAIN_MESSAGE_BIRTHDATE: 'Authentifizieren Sie sich als Datatrain-Mieter:in mit Ihrem Geburtsdatum.',
  SECTION_MAIN_HEADER_CONTRACTBEGINDATE: 'Login mit Ihrem Vertragsbeginn',
  SECTION_MAIN_MESSAGE_CONTRACTBEGINDATE:
    'Authentifizieren Sie sich als Datatrain-Mieter:in mit Ihrem Mietvertragsbeginn. Sie finden diesen auf Ihrem Mietvertrag.',
  SECTION_MAIN_HEADER_CONTRACTBEGIN: 'Login mit Ihrem Vertragsbeginn',
  SECTION_MAIN_MESSAGE_CONTRACTBEGIN:
    'Bitte geben Sie Ihren Vertragsbeginn ein, um sich als Mieter*in der Münchner Wohnen zu authentifizieren. Sollten Sie mehrere Verträge mit der Münchner Wohnen abgeschlossen haben, können Sie den Vertragsbeginn eines beliebigen Vertrags wählen.',
  SECTION_MAIN_BUTTON: 'Weiter',
  'SECTION_MAIN_BUTTON_#ARIA': 'Eingegebenes Datum absenden',
  SECTION_MAIN_BUTTON_BACK: 'Zurück',
  'SECTION_MAIN_BUTTON_BACK_#ARIA': 'Zurück zur Startseite',
  SECTION_MAIN_BUTTON_LANDINGPAGE_BIRTHDATE: 'Mit Mietvertrag authentifizieren',
  SECTION_MAIN_BUTTON_LANDINGPAGE_CONTRACTBEGINDATE: 'Mit Vertragsbegindatum authentifizieren',
  SECTION_MAIN_BUTTON_LANDINGPAGE: 'Anmelden',
  'SECTION_MAIN_BUTTON_LANDINGPAGE_#ARIA': 'Mit eingegeben Datum anmelden',
  SECTION_MAIN_BIRTHDATE: 'Geburtsdatum',
  SECTION_MAIN_CONTRACTBEGINDATE: 'Mietvertragsbeginn',
  SECTION_TILES_HEADER: 'Weitere Login-Optionen',
  SECTION_TILES_SUBHEADER: 'Oder nutzen Sie eine andere Anmeldemöglichkeit.',
  INVALID_INPUT_BIRTHDATE: 'Bitte Vertragsnummer eingeben',
  INVALID_INPUT_CONTRACTBEGINDATE: 'Bitte Mietvertragsbeginn eingeben',
  INVALID_INPUT2: '',
  INVALID_DATE: 'Bitte valides Datum auswählen ',
  INVALID_DATE2: '',
};

export const LANG_DE_LPA_ERROR_TRANS = {
  PAGE_HEADING: 'Ein Fehler ist aufgetreten',
  PAGE_SUBHEADING:
    'Leider ist beim Laden der Seite ein Fehler aufgetreten. Bitte scannen Sie den QR Code auf Ihrem Schreiben erneut.',
};

export const LANG_DE_LPA_CONSENTMANAGEMENT_TRANS = {
  PAGE_HEADER: 'Wie können wir Sie erreichen?',
  PAGE_SUBHEADER: 'Aktualisieren Sie Ihre Kontaktdaten – schnell und einfach',
};

export const LANG_DE_PUBLIC_SURVEY_TRANS = {
  PAGE_HEADING: 'Mieterbefragung',
  PAGE_SUBHEADING: 'Bitte nehmen Sie sich einen Moment Zeit, um an unserer Umfrage teilzunehmen.',
};
